{
  "account.account": "프로필 및 보안",
  "account.accountDeleted": "귀하의 계정이 성공적으로 삭제되었습니다.",
  "account.accountDescription": "이름, 비밀번호, 계정 삭제",
  "account.accountSection": "계정",
  "account.changeEmail": "이메일 변경",
  "account.changePassword": "비밀번호 변경",
  "account.currentPassword": "현재 비밀번호",
  "account.dangerZone": "위험 구역",
  "account.deleteAccount": "계정 삭제",
  "account.deleteAccountConfirmation": "정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
  "account.deleteAccountDescription": "이 작업을 수행하면 귀하의 계정과 모든 정보가 삭제됩니다. 돌아갈 수 없습니다.",
  "account.emailChange": "이메일 주소 변경",
  "account.emailChangeConfirmation": "이메일 변경 확인",
  "account.emailChangeFailure": "이메일 변경 링크가 유효하지 않거나 만료되었습니다.",
  "account.emailChangeIntro": "새 이메일 주소와 현재 비밀번호를 입력하세요. 새 주소로 링크를 보내 드리며, 이메일은 해당 링크를 연 후에만 변경됩니다.",
  "account.emailChangeSuccess": "이메일이 {newEmail} 주소로 성공적으로 변경되었습니다.",
  "account.emailChangeSuccessNoAddress": "이메일 주소가 성공적으로 변경되었습니다.",
  "account.emailChangeVerificationSent": "새 이메일 주소로 확인 이메일이 전송되었습니다. 받은 편지함을 확인하고 링크를 클릭하여 변경을 확인하세요.",
  "account.manageAccount": "계정 관리",
  "account.newEmailAddress": "새 이메일 주소",
  "account.newPassword": "새 비밀번호",
  "account.newPasswordAgain": "새 비밀번호 확인",
  "account.oldPassword": "기존 비밀번호",
  "account.passwordChange": "비밀번호 변경",
  "account.passwordChangeDescription": "계정을 안전하게 유지하세요",
  "account.passwordUpdated": "비밀번호가 성공적으로 업데이트되었습니다.",
  "account.profile": "프로필",
  "account.profileUpdated": "프로필이 성공적으로 업데이트되었습니다.",
  "account.signedInAs": "로그인 계정",
  "account.updateYourProfile": "프로필 업데이트",
  "account.updateYourProfileDescription": "이름 및 표시 설정",
  "addons.accountOnHold": "계정 연결이 만료되었습니다. 데이터 업데이트를 재개하려면 다시 연결해 주세요.",
  "addons.accountOnHoldTitle": "계정 보류 중",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "이 링크에서 API 키를 생성하고 가져오세요.",
  "addons.ambientWeatherDescription": "Ambient Weather 기상 관측소(WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API 키",
  "addons.applicationKey": "애플리케이션 키",
  "addons.availableServices": "사용 가능",
  "addons.cannotDisconnectLastAccount": "유일한 로그인 방법의 연결을 해제할 수 없습니다. 먼저 다른 로그인 방법을 추가하세요.",
  "addons.connect": "연결",
  "addons.connected": "연결됨",
  "addons.connectedAccounts": "연결된 계정",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "연결된 계정을 불러오는 중…",
  "addons.connectedServices": "연결됨",
  "addons.connectedSince": "{date}부터 연결됨",
  "addons.connectionSection": "연결",
  "addons.connectionSuccess": "{provider} 계정이 성공적으로 연결되었습니다",
  "addons.davisApiSecret": "API 비밀",
  "addons.davisApiV2Key": "V2 API 키",
  "addons.davisDescription": "Davis 기상 관측소(Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "이 링크에서 V2 API 키를 가져오세요.",
  "addons.disconnect": "연결 해제",
  "addons.disconnectConfirmation": "{provider} 계정 연결을 해제하시겠습니까?",
  "addons.disconnectEnergyConfirmation": "SmartMixin이 Netatmo Energy 동기화를 중지하고 SmartMixin에서 집을 제거합니다. Netatmo 계정과 기기에는 영향이 없습니다.",
  "addons.disconnectEnergyDescription": "동기화를 중지하고 SmartMixin에서 집을 제거합니다.",
  "addons.disconnectionSuccess": "{provider} 계정이 성공적으로 연결 해제되었습니다",
  "addons.disconnectProviderDescription": "동기화를 중지하고 이 서비스의 관측소와 그 기록을 삭제합니다.",
  "addons.disconnectServiceConfirmation": "SmartMixin이 {provider} 동기화를 중지하고 이 서비스의 관측소와 모든 기록을 삭제합니다. {provider} 계정 자체에는 영향이 없습니다.",
  "addons.disconnectServiceTitle": "{provider} 연결을 해제할까요?",
  "addons.ecowittCreateAndRetrieveKeys": "이 링크에서 API 키와 애플리케이션 키를 모두 생성하고 가져오세요.",
  "addons.ecowittDescription": "Ecowitt는 전문 Wi-Fi 기상 관측소, 무선 실내 실외 온도계, 습도 모니터, 고정밀 우량계, 공기 품질 모니터 등을 제공합니다.",
  "addons.helpLink": "{provider} 연결 방법",
  "addons.integrationsSection": "통합",
  "addons.myAcuriteAccountOnHold": "귀하의 계정이 보류되었습니다. 계정을 다시 연결하려면 비밀번호를 입력하세요",
  "addons.myAcuriteDescription": "AcuRite는 북미 최고의 기상 관측소 브랜드입니다. 시간, 온도, 기상 기술 분야의 선두주자인 AcuRite는 실내 및 실외 환경에 대한 자세한 정보를 제공하므로 귀하는 자신 있게 하루를 계획할 수 있습니다.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Netatmo 온도 조절기를 사용하여 침대에서나 지구 반대편에서 집의 온도를 변경하세요.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "집에 있는 개인 기상 관측소",
  "addons.notConnected": "연결되지 않음",
  "addons.or": "또는",
  "addons.providerAccountDisconnected": "기상 서비스 연결이 만료되었습니다. 데이터 업데이트를 재개하려면 다시 연결해 주세요.",
  "addons.reconnect": "다시 연결",
  "addons.socialConnectionsIntro": "소셜 계정을 연결하여 빠르게 로그인하세요. 언제든지 계정을 연결하거나 연결 해제할 수 있습니다.",
  "addons.weatherflowAccessToken": "액세스 토큰",
  "addons.weatherflowCreateToken": "이 링크에서 토큰을 생성하고 가져오세요.",
  "addons.weatherflowTempestDescription": "풍속계와 우량계가 내장된 Tempest 기상 시스템",
  "addons.weatherServices": "기상 서비스",
  "addons.weatherServicesConnected": "{count, plural, =0 {연결된 서비스 없음} other {#개의 서비스가 연결됨}}",
  "addons.weatherServicesDescription": "Netatmo, Davis, Weatherflow 등 연결",
  "addons.wundergroundApiKey": "API 키",
  "addons.wundergroundDescription": "Weather Underground는 기상 관측소 및 대기 질 모니터와 같은 환경 센서의 데이터를 연결하는 사람들로 구성된 글로벌 커뮤니티로, 열정을 키우는 데 필요한 풍부한 지역 데이터를 제공할 수 있습니다.",
  "addons.wundergroundRemoveStationDescription": "스테이션이 SmartMixin 계정에서 제거됩니다. 다른 SmartMixin 계정에서도 추가하지 않았다면 스테이션과 SmartMixin이 기록한 기록이 삭제됩니다. Weather Underground에서는 아무것도 바뀌지 않습니다.",
  "addons.wundergroundRemoveStationTitle": "{station}을(를) 삭제할까요?",
  "addons.wundergroundRetrieveApiKey": "이 링크에서 API 키를 가져오세요.",
  "addons.wundergroundStationId": "스테이션 ID",
  "airQuality.adviceActivityGood": "야외 활동을 하기에 아주 좋은 날입니다",
  "airQuality.adviceActivityHazardous": "야외에서의 모든 신체 활동을 피하세요",
  "airQuality.adviceActivityLabel": "신체 활동",
  "airQuality.adviceActivityModerate": "야외 활동을 하기에 좋은 날입니다",
  "airQuality.adviceActivitySensitive": "야외 활동을 더 짧고 덜 격렬하게 하는 것을 고려하세요",
  "airQuality.adviceActivityUnhealthy": "장시간 또는 격렬한 활동을 줄이고 휴식을 더 자주 취하세요",
  "airQuality.adviceActivityVeryUnhealthy": "장시간 또는 격렬한 활동을 피하고 실내로 옮기는 것을 고려하세요",
  "airQuality.adviceGroupsGood": "특별한 주의가 필요하지 않습니다",
  "airQuality.adviceGroupsHazardous": "실내에 머물고 활동량을 낮게 유지하세요",
  "airQuality.adviceGroupsLabel": "민감군",
  "airQuality.adviceGroupsModerate": "특히 민감한 분: 활동을 더 짧고 덜 격렬하게 하세요",
  "airQuality.adviceGroupsSensitive": "야외 활동을 더 짧고 덜 격렬하게 하고 휴식을 더 자주 취하세요",
  "airQuality.adviceGroupsUnhealthy": "장시간 또는 격렬한 야외 활동을 피하고 실내로 옮기는 것을 고려하세요",
  "airQuality.adviceGroupsVeryUnhealthy": "야외에서의 모든 신체 활동을 피하고 일정을 미루거나 실내로 옮기세요",
  "airQuality.adviceTimingLabel": "외출 시간",
  "airQuality.adviceTimingMorning": "오전이 좋습니다 — 오존 농도가 더 낮습니다",
  "airQuality.airQuality": "공기질",
  "airQuality.airQualityIndex": "대기 질 지수",
  "airQuality.aqiForecast": "대기질 예보",
  "airQuality.co2Fresh": "쾌적",
  "airQuality.co2GettingStale": "약간 탁함",
  "airQuality.co2Stale": "탁함",
  "airQuality.dailyForecast": "일일예보",
  "airQuality.dominantPollutant": "주요 오염물질",
  "airQuality.expectedPeak": "예상 최고치",
  "airQuality.good": "좋음",
  "airQuality.goodDescription": "대기 질은 만족스러운 것으로 간주되며 대기 오염으로 인한 위험은 거의 또는 전혀 없습니다.",
  "airQuality.hazardous": "위험",
  "airQuality.hazardousDescription": "건강 경고: 누구나 건강에 더 심각한 영향을 미칠 수 있습니다",
  "airQuality.indoorAirQuality": "실내공기질",
  "airQuality.moderate": "보통",
  "airQuality.moderateDescription": "공기질은 괜찮습니다. 그러나 일부 오염 물질의 경우 대기 오염에 매우 민감한 극소수의 사람들에게는 중간 정도의 건강 문제가 있을 수 있습니다.",
  "airQuality.noForecastForLocation": "이 위치의 대기질 예보를 제공할 수 없습니다.",
  "airQuality.now": "현재",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "오염물질",
  "airQuality.recommendations": "권장 사항",
  "airQuality.sensitiveUnhealthy": "민감군에게 건강에 해로움",
  "airQuality.sensitiveUnhealthyDescription": "민감한 그룹의 구성원은 건강에 영향을 미칠 수 있습니다. 일반 대중은 영향을 받을 가능성이 없습니다.",
  "airQuality.subIndex": "AQI 하위 지수",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "지수 이해하기",
  "airQuality.unhealthy": "건강에 해로움",
  "airQuality.unhealthyDescription": "모든 사람이 건강에 영향을 받기 시작할 수 있습니다. 민감한 그룹의 구성원은 건강에 더 심각한 영향을 미칠 수 있습니다.",
  "airQuality.veryUnhealthy": "매우 건강에 해로움",
  "airQuality.veryUnhealthyDescription": "비상 상황에 대한 건강 경고. 전체 인구가 영향을 받을 가능성이 더 높습니다.",
  "alerts.addAlert": "알림 추가",
  "alerts.addCondition": "조건 추가",
  "alerts.alertAdded": "알림이 추가되었습니다.",
  "alerts.alertAuthorizationNotice": "알림은 SmartMixin이 알림을 표시하도록 승인한 경우에만 작동합니다.",
  "alerts.alertDeleted": "알림이 삭제되었습니다.",
  "alerts.alertName": "알림 이름",
  "alerts.alertWhen": "다음과 같은 경우에 알림을 받고 싶습니다.",
  "alerts.aqiGreaterThan": "다음보다 큰 AQI",
  "alerts.aqiGreaterThanThreshold": "AQI가 {value}{unit} 임계값보다 큼",
  "alerts.aqiLessThan": "AQI 미만",
  "alerts.aqiLessThanThreshold": "AQI가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.atLeastOneCondition": "조건을 하나 이상 추가해야 합니다.",
  "alerts.co2GreaterThan": "CO2가 다음보다 큼",
  "alerts.co2GreaterThanThreshold": "CO2가 {value}{unit} 임계값보다 큼",
  "alerts.co2LessThan": "CO2 미만",
  "alerts.co2LessThanThreshold": "CO2가 {value}{unit} 기준치보다 낮습니다.",
  "alerts.conditions": "조건",
  "alerts.conditionsDroppedOnStationChange": "이 관측소에서 지원하지 않아 삭제됨: {conditions}",
  "alerts.createAlert": "알림 만들기",
  "alerts.dailyPrecipitationGreaterThan": "일 강수량 초과",
  "alerts.dailyPrecipitationGreaterThanThreshold": "일 강수량 {value}{unit} 임계값 초과",
  "alerts.deleteAlert": "알림 삭제",
  "alerts.editAlert": "알림 수정",
  "alerts.editCondition": "조건 편집",
  "alerts.gustSpeedGreaterThan": "다음보다 큰 돌풍 속도",
  "alerts.gustSpeedGreaterThanThreshold": "{value}{unit} 임계값보다 큰 돌풍 속도",
  "alerts.gustSpeedLessThan": "돌풍 속도 미만",
  "alerts.gustSpeedLessThanThreshold": "돌풍 속도가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.heatIndexGreaterThan": "열지수 초과",
  "alerts.heatIndexGreaterThanThreshold": "열지수가 {value}{unit} 임계값보다 높습니다.",
  "alerts.heatIndexLessThan": "열지수 미만",
  "alerts.heatIndexLessThanThreshold": "열지수가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.humidexGreaterThan": "휴미덱스 초과",
  "alerts.humidexGreaterThanThreshold": "휴미덱스가 {value}{unit} 임계값보다 높습니다.",
  "alerts.humidexLessThan": "휴미덱스 미만",
  "alerts.humidexLessThanThreshold": "휴미덱스가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.humidityGreaterThan": "다음보다 높은 습도",
  "alerts.humidityGreaterThanThreshold": "{value}{unit} 임계값보다 높은 습도",
  "alerts.humidityLessThan": "습도 미만",
  "alerts.humidityLessThanThreshold": "{value}{unit} 임계값보다 낮은 습도",
  "alerts.inProgress": "진행 중",
  "alerts.leafWetnessGreaterThan": "다음보다 높은 잎 젖음",
  "alerts.leafWetnessGreaterThanThreshold": "{value}{unit} 임계값보다 높은 잎 젖음",
  "alerts.leafWetnessLessThan": "잎 젖음 미만",
  "alerts.leafWetnessLessThanThreshold": "{value}{unit} 임계값보다 낮은 잎 젖음",
  "alerts.myAlerts": "내 알림",
  "alerts.noConfiguredAlert": "아직 구성된 알림이 없습니다. 알림을 추가하세요.",
  "alerts.noiseGreaterThan": "다음보다 큰 소음",
  "alerts.noiseGreaterThanThreshold": "{value}{unit} 임계값보다 큰 소음",
  "alerts.noiseLessThan": "소음 미만",
  "alerts.noiseLessThanThreshold": "{value}{unit} 임계값보다 작은 소음",
  "alerts.noteOnConditions": "아래 조건이 모두 확인되면 경고가 트리거됩니다.",
  "alerts.noTriggerHistory": "이 알림은 아직 작동한 적이 없습니다.",
  "alerts.pm10GreaterThan": "PM 10 이상",
  "alerts.pm10GreaterThanThreshold": "PM 10이 {value}{unit} 임계값보다 큼",
  "alerts.pm10LessThan": "PM 10 미만",
  "alerts.pm10LessThanThreshold": "PM 10이 {value}{unit} 임계값보다 적습니다.",
  "alerts.pm1GreaterThan": "PM 1보다 큼",
  "alerts.pm1GreaterThanThreshold": "PM 1이 {value}{unit} 임계값보다 큼",
  "alerts.pm1LessThan": "PM 1 미만",
  "alerts.pm1LessThanThreshold": "PM 1이 {value}{unit} 임계값보다 작습니다.",
  "alerts.pm2p5GreaterThan": "PM 2.5 이상",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5가 {value}{unit} 임계값보다 큼",
  "alerts.pm2p5LessThan": "PM 2.5 미만",
  "alerts.pm2p5LessThanThreshold": "PM 2.5가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.postStormSummary": "강우 후 요약",
  "alerts.postStormSynopsisHelper": "강우가 끝날 때마다 요약 알림을 받게 됩니다.",
  "alerts.postStormSynopsisSoleCondition": "강우 후 요약은 다른 조건과 결합할 수 없습니다.",
  "alerts.precipitationGreaterThan": "시간당 강수량 초과",
  "alerts.precipitationGreaterThanThreshold": "시간당 강수량 {value}{unit} 임계값 초과",
  "alerts.pressureGreaterThan": "다음보다 큰 압력",
  "alerts.pressureGreaterThanThreshold": "{value}{unit} 임계값보다 큰 압력",
  "alerts.pressureLessThan": "압력 미만",
  "alerts.pressureLessThanThreshold": "{value}{unit} 임계값보다 낮은 압력",
  "alerts.rainRateGreaterThan": "강수 강도 초과",
  "alerts.rainRateGreaterThanThreshold": "강수 강도 {value}{unit} 임계값 초과",
  "alerts.sensorNotReporting": "이 센서는 현재 데이터를 보내지 않고 있습니다. 데이터가 다시 들어오면 알림이 재개됩니다.",
  "alerts.soilMoistureGreaterThan": "다음보다 높은 토양 수분",
  "alerts.soilMoistureGreaterThanThreshold": "{value}{unit} 임계값보다 높은 토양 수분",
  "alerts.soilMoistureLessThan": "토양 수분 미만",
  "alerts.soilMoistureLessThanThreshold": "{value}{unit} 임계값보다 낮은 토양 수분",
  "alerts.solarRadiationGreaterThan": "다음보다 큰 태양 복사",
  "alerts.solarRadiationGreaterThanThreshold": "{value}{unit} 임계값보다 큰 태양 복사",
  "alerts.solarRadiationLessThan": "다음보다 적은 태양 복사",
  "alerts.solarRadiationLessThanThreshold": "{value}{unit} 임계값보다 작은 태양 복사",
  "alerts.stationNoLongerReports": "이 관측소는 더 이상 데이터를 보내지 않으므로 이 알림은 작동하지 않습니다.",
  "alerts.stormChartUnavailable": "이 강우에 대한 강우 기록을 사용할 수 없습니다.",
  "alerts.stormDetail": "강우 요약",
  "alerts.stormDuration": "지속 시간",
  "alerts.stormEnd": "종료",
  "alerts.stormPeakRate": "최대 강우 강도",
  "alerts.stormStart": "시작",
  "alerts.stormTotal": "총 강우량",
  "alerts.temperatureGreaterThan": "다음보다 큰 온도",
  "alerts.temperatureGreaterThanThreshold": "{value}{unit} 임계값보다 높은 온도",
  "alerts.temperatureLessThan": "온도 미만",
  "alerts.temperatureLessThanThreshold": "온도가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.thresholdOutOfRange": "{min}에서 {max} 사이여야 합니다",
  "alerts.thswGreaterThan": "THSW 초과",
  "alerts.thswGreaterThanThreshold": "THSW가 {value}{unit} 임계값보다 높습니다.",
  "alerts.thswLessThan": "THSW 미만",
  "alerts.thswLessThanThreshold": "THSW가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.thwGreaterThan": "THW 초과",
  "alerts.thwGreaterThanThreshold": "THW가 {value}{unit} 임계값보다 높습니다.",
  "alerts.thwLessThan": "THW 미만",
  "alerts.thwLessThanThreshold": "THW가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.triggerHistory": "알림 기록",
  "alerts.uvGreaterThan": "UV 지수가 다음보다 큼",
  "alerts.uvGreaterThanThreshold": "UV 지수가 {value}{unit} 임계값보다 큽니다.",
  "alerts.uvLessThan": "자외선 지수 미만",
  "alerts.uvLessThanThreshold": "UV 지수가 {value}{unit} 임계값보다 작습니다.",
  "alerts.visibilityGreaterThanThreshold": "가시성이 {value}{unit} 기준점보다 큼",
  "alerts.visibilityLessThanThreshold": "가시성이 {value}{unit} 기준점보다 낮습니다.",
  "alerts.visiblityGreaterThan": "다음보다 큰 가시성",
  "alerts.visiblityLessThan": "가시성 미만",
  "alerts.whichMeasure": "어떤 측정값에 대해 알림을 받고 싶으신가요?",
  "alerts.whichModule": "어떤 모듈에 대해 알림을 받으시겠습니까?",
  "alerts.whichSensor": "어떤 센서에 대해 알림을 받으시겠습니까?",
  "alerts.windChillGreaterThan": "풍속 냉각 초과",
  "alerts.windChillGreaterThanThreshold": "풍속 냉각이 {value}{unit} 임계값보다 높습니다.",
  "alerts.windChillLessThan": "풍속 냉각 미만",
  "alerts.windChillLessThanThreshold": "풍속 냉각이 {value}{unit} 임계값보다 낮습니다.",
  "alerts.windSpeedGreaterThan": "다음보다 큰 풍속",
  "alerts.windSpeedGreaterThanThreshold": "{value}{unit} 임계값보다 큰 풍속",
  "alerts.windSpeedLessThan": "풍속 미만",
  "alerts.windSpeedLessThanThreshold": "{value}{unit} 임계값보다 낮은 풍속",
  "appUpdate.updateAvailable": "업데이트 가능",
  "appUpdate.updateAvailableOpenAppStore": "탭하여 App Store 열기",
  "appUpdate.updateAvailableOpenGooglePlay": "탭하여 Google Play 열기",
  "appUpdate.updateAvailableVersion": "업데이트 가능: v{version}",
  "appUpdate.upgradeRequiredAndroid": "애플리케이션을 업그레이드해야 합니다. 업그레이드하려면 Google Play를 방문하세요.",
  "appUpdate.upgradeRequiredIos": "애플리케이션을 업그레이드해야 합니다. 업그레이드하려면 App Store를 방문하세요.",
  "astral.aboveHorizonAllDay": "하루 종일 지평선 위",
  "astral.aboveTheHorizon": "지평선 위",
  "astral.apparentSize": "겉보기 크기",
  "astral.apparentSizeAcross": "시직경 {size}",
  "astral.astronomicalDawn": "천문박명 시작",
  "astral.astronomicalDusk": "천문박명 종료",
  "astral.belowHorizonAllDay": "하루 종일 지평선 아래",
  "astral.belowHorizonSince": "{time}부터 지평선 아래",
  "astral.belowHorizonSinceOn": "{day} {time}부터 지평선 아래",
  "astral.brightAllNight": "밤새 밝음 — 완전히 어두워지지 않음",
  "astral.brightestMoment": "가장 밝은 순간",
  "astral.civilDawn": "시민박명 시작",
  "astral.civilDusk": "시민박명 종료",
  "astral.darkSkyBetween": "어두운 하늘 {from} → {to}",
  "astral.darkSkyWindow": "어두운 하늘 {from} → {to} · 달 없는 시간 {duration}",
  "astral.dayLength": "낮 길이",
  "astral.daylightThroughTheYear": "연중 낮 길이",
  "astral.dayOfCycle": "{total}일 중 {day}일째",
  "astral.doesNotOccurToday": "오늘은 발생하지 않습니다",
  "astral.domeHint": "드래그하여 밤을 따라가기",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "가장 이른 일출",
  "astral.earliestSunset": "가장 이른 일몰",
  "astral.equinox": "분점",
  "astral.equinoxIn": "{days}일 후 분점",
  "astral.evening": "저녁",
  "astral.exactPhaseAt": "정확한 시각 {time}",
  "astral.firstQuarter": "상현달",
  "astral.firstSunriseIn": "{days}일 후 첫 일출",
  "astral.firstSunsetIn": "{days}일 후 첫 일몰",
  "astral.fullMoon": "보름달",
  "astral.goldenHourBegins": "골든아워 시작",
  "astral.goldenHourEnds": "골든아워 종료",
  "astral.highestPoint": "최고 고도",
  "astral.inDays": "{days}일 후",
  "astral.lastQuarter": "하현달",
  "astral.latestSunrise": "가장 늦은 일출",
  "astral.latestSunset": "가장 늦은 일몰",
  "astral.litShort": "밝은 면",
  "astral.longestDay": "낮이 가장 긴 날",
  "astral.lowestPoint": "최저 고도",
  "astral.maxAltitudeShort": "최대",
  "astral.midday": "정오",
  "astral.midnightSun": "백야",
  "astral.midnightSunPeriod": "백야",
  "astral.milestoneFootnotePolar": "이곳에서는 일 년 중 {days, plural, other {#일}} 동안 해가 뜨지도 지지도 않으므로, 일반적인 일출·일몰 극값 대신 그 기간을 표시합니다.",
  "astral.milestoneFootnoteTemperate": "가장 이른 일몰과 가장 늦은 일출은 가장 짧은 날에 오지 않습니다 — 이 두 날짜는 지점이 아니라 균시차가 정합니다.",
  "astral.moon": "달",
  "astral.moonAltitude": "고도",
  "astral.moonDirection": "방위",
  "astral.moonDistance": "거리",
  "astral.moonlessFor": "달 없는 시간 {duration}",
  "astral.moonPhases": "달의 위상",
  "astral.moonrise": "월출",
  "astral.moonset": "월몰",
  "astral.moonUpAllNight": "달이 밤새 떠 있음",
  "astral.moonWashesOutNight": "달이 {rise}부터 {set}까지 떠 있어 밤새 하늘을 밝힘",
  "astral.morning": "아침",
  "astral.nauticalDawn": "항해박명 시작",
  "astral.nauticalDusk": "항해박명 종료",
  "astral.newMoon": "삭",
  "astral.nextDay": "다음 날",
  "astral.nextProperlyDarkNight": "다음으로 정말 어두운 밤",
  "astral.nextRise": "다음 월출 {time}",
  "astral.nextRiseOn": "다음 월출 {day} {time}",
  "astral.nextSevenNights": "다음 7일 밤",
  "astral.nightDate": "날짜",
  "astral.noAstronomicalDarknessTonight": "오늘 밤은 천문박명이 끝나지 않음",
  "astral.noDarkNightAhead": "앞으로 2주간 없음",
  "astral.noStationLocation": "위치를 알 수 없음",
  "astral.noStationLocationDescription": "이 관측소에는 등록된 위치가 없어 해와 달을 계산할 수 없습니다.",
  "astral.noSunriseToday": "오늘은 일출이 없습니다",
  "astral.nowAtBearing": "현재 고도 {altitude}, 방위 {direction}",
  "astral.observing": "관측",
  "astral.ofDaylightLeft": "낮 시간 남음",
  "astral.overTheNextThreeWeeks": "향후 3주간",
  "astral.percentLit": "밝은 부분 {percent}",
  "astral.polarNight": "극야",
  "astral.polarNightPeriod": "극야",
  "astral.rightNow": "지금",
  "astral.riseShort": "월출",
  "astral.setShort": "월몰",
  "astral.shortestDay": "낮이 가장 짧은 날",
  "astral.solarNoon": "남중시각",
  "astral.solstice": "지점",
  "astral.sunBelowHorizon": "태양이 지평선 아래 {degrees}°",
  "astral.sunEvents": "태양 이벤트",
  "astral.sunNeverDarkEnough": "태양이 지평선 아래 18°까지 내려가지 않음",
  "astral.sunNeverSets": "해가 지지 않습니다",
  "astral.sunrise": "해돋이",
  "astral.sunriseAndSunset": "일출과 일몰",
  "astral.sunriseAt": "일출 {time}",
  "astral.sunset": "일몰",
  "astral.sunsetAt": "일몰 {time}",
  "astral.thisYearAtNorth": "올해 북위 {degrees}도",
  "astral.thisYearAtSouth": "올해 남위 {degrees}도",
  "astral.tonight": "오늘 밤",
  "astral.twilightAllNight": "밤새 박명 — 완전히 어두워지지 않음",
  "astral.upFor": "{duration} 동안 떠 있음",
  "astral.usableLight": "밝은 시간",
  "astral.vsAverage": "평균 대비 {percent}",
  "astral.vsYesterday": "어제 대비",
  "astral.waningCrescent": "그믐달",
  "astral.waningGibbous": "이지러지는 볼록달",
  "astral.waxingCrescent": "초승달",
  "astral.waxingGibbous": "차오르는 볼록달",
  "astral.whereToLook": "바라볼 방향",
  "astral.withoutTheMoon": "달 없는 시간 {duration}",
  "auth.alreadyHaveAccount": "이미 계정이 있으신가요?",
  "auth.authContainerTagline": "나만의 날씨 대시보드. 스테이션을 연결하고 실시간 데이터를 손끝에서 확인하세요.",
  "auth.backToLogin": "로그인으로 돌아가기",
  "auth.checkYourEmail": "이메일을 확인하세요",
  "auth.continueWithApple": "Apple로 계속하기",
  "auth.continueWithFacebook": "Facebook으로 계속하기",
  "auth.continueWithGoogle": "Google로 계속하기",
  "auth.email": "이메일 주소",
  "auth.emailRequiredLoginFacebook": "이메일 권한이 필요합니다.",
  "auth.emailVerification": "이메일 인증",
  "auth.emailVerificationFailure": "이메일 확인에 문제가 발생했습니다.",
  "auth.emailVerificationSuccess": "귀하의 이메일이 성공적으로 확인되었습니다.",
  "auth.firstName": "이름",
  "auth.forgotPassword": "비밀번호를 잊으셨나요?",
  "auth.forgotPasswordSubtitle": "이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
  "auth.lastName": "성",
  "auth.login": "로그인",
  "auth.loginSubtitle": "다시 오신 것을 환영합니다! 정보를 입력해 주세요.",
  "auth.loginToSmartMixinDescription": "SmartMixin에 로그인하여 기상 관측소에 액세스하고, 분석을 확인하고, 나만의 날씨 대시보드를 관리하세요.",
  "auth.logout": "로그아웃",
  "auth.logoutConfirmation": "로그아웃하시겠습니까?",
  "auth.noAccountYet": "아직 계정이 없으신가요?",
  "auth.or": "또는",
  "auth.password": "비밀번호",
  "auth.passwordReset": "비밀번호 초기화",
  "auth.passwordResetSuccess": "귀하의 비밀번호가 성공적으로 업데이트되었습니다.",
  "auth.register": "계정 만들기",
  "auth.registerDescription": "무료 SmartMixin 계정을 만들어 기상 관측소를 연결하고, 날씨 데이터를 추적하고, 강력한 분석 도구에 액세스하세요.",
  "auth.registerSubtitle": "시작하려면 계정을 만드세요.",
  "auth.restorePassword": "비밀번호 복원",
  "auth.restorePasswordSuccess": "추가 지침이 포함된 비밀번호 재설정 링크를 {emailAddress} 로 보내드렸습니다.",
  "auth.sendReset": "재설정 지침 보내기",
  "auth.signInWithApple": "Apple로 로그인",
  "auth.socialAccount": "또는 귀하의 계정을 사용하십시오",
  "auth.staffVerificationCode": "인증 코드",
  "auth.staffVerificationExpiresIn": "인증되었습니다. {duration} 후 만료됩니다.",
  "auth.staffVerificationInvalidCode": "코드가 올바르지 않습니다. 다시 시도하세요.",
  "auth.staffVerificationLoginAsStopped": "Login As가 중지되었습니다. 계속하려면 Debug 화면에서 인증 코드를 입력하세요.",
  "auth.staffVerificationNotEnrolled": "계정에 인증 앱이 설정되어 있지 않습니다. 백오피스 보안 설정에서 추가하세요.",
  "auth.staffVerificationPrompt": "Login As 및 사용자 검색을 사용하려면 인증 앱의 6자리 코드 또는 복구 코드를 입력하세요.",
  "auth.staffVerificationSetupLink": "인증 앱 추가",
  "auth.staffVerificationSubmit": "인증",
  "auth.staffVerificationTitle": "직원 인증",
  "calendar.afternoon": "오후",
  "calendar.april": "4월",
  "calendar.august": "8월",
  "calendar.changePeriod": "기간: {period}. 기간 변경",
  "calendar.currentDay": "오늘",
  "calendar.dateFormat": "날짜 형식",
  "calendar.day": "일",
  "calendar.december": "12월",
  "calendar.durationHours": "{hours}시간",
  "calendar.durationHoursMinutes": "{hours}시간 {minutes}분",
  "calendar.durationMinutes": "{minutes}분",
  "calendar.durationMinutesSeconds": "{minutes}분 {seconds}초",
  "calendar.durationSeconds": "{seconds}초",
  "calendar.earlierYears": "이전 연도",
  "calendar.endTime": "종료 시간",
  "calendar.evening": "밤",
  "calendar.february": "2월",
  "calendar.goToNextDay": "다음 날",
  "calendar.goToNextMonth": "다음 달",
  "calendar.goToNextWeek": "다음 주",
  "calendar.goToNextYear": "다음 연도",
  "calendar.goToPreviousDay": "이전 날",
  "calendar.goToPreviousMonth": "이전 달",
  "calendar.goToPreviousWeek": "이전 주",
  "calendar.goToPreviousYear": "이전 연도",
  "calendar.hour": "시각",
  "calendar.hoursCount": "{count, plural, other {#시간}}",
  "calendar.hoursShort": "시간",
  "calendar.hoursShortCount": "{count, plural, other {#시간}}",
  "calendar.january": "1월",
  "calendar.july": "7월",
  "calendar.june": "6월",
  "calendar.last12Hours": "지난 12시간",
  "calendar.last24Hours": "지난 24시간",
  "calendar.last30Days": "지난 30일",
  "calendar.last3Hours": "지난 3시간",
  "calendar.last6Hours": "지난 6시간",
  "calendar.last7Days": "지난 7일",
  "calendar.lastHour": "지난 1시간",
  "calendar.laterYears": "이후 연도",
  "calendar.march": "3월",
  "calendar.max": "최대",
  "calendar.may": "5월",
  "calendar.month": "월",
  "calendar.monthTotal": "월 합계",
  "calendar.morning": "아침",
  "calendar.nextHours": "향후 몇 시간",
  "calendar.night": "새벽",
  "calendar.november": "11월",
  "calendar.october": "10월",
  "calendar.oneDay": "1일",
  "calendar.oneHour": "1시간",
  "calendar.oneMonth": "1개월",
  "calendar.oneWeek": "1주",
  "calendar.periodRangeSpoken": "{start}부터 {end}까지",
  "calendar.previous24Hours": "이전 24시간",
  "calendar.previous30Days": "이전 30일",
  "calendar.previous7Days": "이전 7일",
  "calendar.previousDay": "전날",
  "calendar.previousHours": "이전 시간",
  "calendar.previousMonth": "전월",
  "calendar.previousWeek": "전주",
  "calendar.previousYear": "전년도",
  "calendar.sameDayLastYear": "작년 같은 날",
  "calendar.sameMonthLastYear": "작년 같은 달",
  "calendar.selectADate": "날짜를 선택하십시오",
  "calendar.selectAggregation": "표시할 값 선택",
  "calendar.selectAMonth": "월을 선택하십시오",
  "calendar.selectAYear": "연도를 선택하십시오",
  "calendar.selectGranularity": "데이터 간격 선택",
  "calendar.selectPeriod": "기간을 선택하십시오",
  "calendar.september": "9월",
  "calendar.sixHours": "6시간",
  "calendar.startTime": "시작 시간",
  "calendar.thirtyMinutes": "30분",
  "calendar.threeHours": "3시간",
  "calendar.timezone": "시간대",
  "calendar.today": "오늘",
  "calendar.untilChanged": "변경될 때까지",
  "calendar.untilTime": "{time} 까지",
  "calendar.untilTodayAt": "오늘 {time}까지",
  "calendar.untilTomorrowAt": "내일 {time}까지",
  "calendar.use24HourFormat": "24시간 형식 사용",
  "calendar.week": "주",
  "calendar.year": "년도",
  "calendar.yearToDate": "올해 초부터 현재까지",
  "calendar.yesterday": "어제",
  "charts.averageOverThePeriod": "해당 기간의 평균",
  "charts.calendarView": "달력 보기",
  "charts.charts": "차트",
  "charts.chartView": "차트 보기",
  "charts.comparison": "비교",
  "charts.customizeComparisonMetrics": "지표 맞춤설정",
  "charts.customizeComparisonMetricsDescription": "항목을 드래그하여 비교 지표를 재정렬하세요. 눈 아이콘을 탭하여 지표를 표시하거나 숨길 수 있습니다.",
  "charts.loading": "차트를 불러오는 중",
  "charts.maxOverThePeriod": "해당 기간의 최대",
  "charts.measureToDisplay": "표시할 측정값",
  "charts.minMaxRange": "최소 / 최대",
  "charts.noDataForThisPeriod": "이 기간에 대한 데이터가 없습니다.",
  "charts.observations": "관측값",
  "charts.observedTemperature": "관측 기온",
  "charts.seriesTableDate": "날짜",
  "charts.showComparison": "비교 표시",
  "charts.stationComparison": "관측소 비교",
  "charts.stationComparisonDescription": "과거 기상 데이터를 다른 관측소와 비교",
  "charts.sumOverThePeriod": "해당 기간 동안 누적",
  "charts.tableLabel": "{chart} 표",
  "charts.toggleSeries": "{series} 표시 또는 숨기기",
  "charts.viewAsChart": "차트",
  "charts.viewAsList": "목록",
  "charts.viewAsPeriods": "시간대",
  "charts.viewAsTable": "표",
  "charts.viewLabel": "{chart} 보기",
  "common.add": "추가",
  "common.altitude": "고도",
  "common.analysis": "분석",
  "common.average": "평균",
  "common.back": "뒤로",
  "common.backToHome": "홈으로 돌아가기",
  "common.cancel": "취소",
  "common.cannotBeEmpty": "이 필드는 비워둘 수 없습니다.",
  "common.close": "닫기",
  "common.dailyForecast": "일일예보",
  "common.default": "기본값",
  "common.delete": "삭제",
  "common.details": "세부 정보",
  "common.edit": "편집",
  "common.exitFullscreen": "전체 화면 종료",
  "common.forecast": "예보",
  "common.frequency": "빈도",
  "common.full": "완충",
  "common.fullscreen": "전체 화면",
  "common.help": "도움말",
  "common.hidden": "숨김",
  "common.high": "높음",
  "common.iDontKnowYet": "아직은 모르겠어요",
  "common.indoor": "실내",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "마지막 업데이트",
  "common.low": "낮음",
  "common.maximum": "최대",
  "common.medium": "중간",
  "common.minimum": "최소",
  "common.more": "더보기",
  "common.moreInformation": "추가 정보",
  "common.next": "다음",
  "common.no": "아니요",
  "common.noAccountNeeded": "계정 필요 없음",
  "common.noItemsAvailable": "사용할 수 있는 항목이 없습니다",
  "common.notNow": "나중에",
  "common.now": "현재",
  "common.openSettings": "설정 열기",
  "common.outdoor": "실외",
  "common.pageNotFound": "페이지를 찾을 수 없습니다",
  "common.pageNotFoundDescription": "찾고 있는 페이지가 존재하지 않거나 이동되었습니다.",
  "common.rain": "비",
  "common.reorderCancel": "{item} 이동을 취소했습니다. {count}개 중 {position}번째로 돌아갔습니다.",
  "common.reorderEnd": "{item}을(를) {count}개 중 {position}번째에 놓았습니다.",
  "common.reorderInstructions": "이 항목을 이동하려면 스페이스 키나 Enter 키를 누르고 위아래 화살표 키로 위치를 고른 다음, 스페이스 키나 Enter 키를 다시 눌러 놓거나 Esc 키를 눌러 취소하세요.",
  "common.reorderOver": "{item}이(가) 이제 {count}개 중 {position}번째입니다.",
  "common.reorderStart": "{item}을(를) 잡았습니다. {count}개 중 {position}번째입니다.",
  "common.share": "공유",
  "common.shareImageFailed": "이미지를 공유하지 못했습니다",
  "common.shareYourWeather": "날씨를 공유하세요",
  "common.skip": "건너뛰기",
  "common.start": "시작",
  "common.unknown": "알 수 없음",
  "common.validate": "확인",
  "common.validEmail": "유효한 이메일 주소가 필요합니다.",
  "common.very_low": "매우 낮음",
  "common.weatherObservations": "기상 관측",
  "common.welcome": "SmartMixin에 오신 것을 환영합니다!",
  "common.wind": "바람",
  "common.yes": "예",
  "common.zoomImage": "이미지 확대",
  "compass.E": "동",
  "compass.E_long": "동쪽",
  "compass.ENE": "동북동",
  "compass.ENE_long": "동북동",
  "compass.ESE": "동남동",
  "compass.ESE_long": "동남동",
  "compass.N": "북",
  "compass.N_long": "북쪽",
  "compass.NE": "북동",
  "compass.NE_long": "북동",
  "compass.NNE": "북북동",
  "compass.NNE_long": "북북동",
  "compass.NNW": "북북서",
  "compass.NNW_long": "북북서",
  "compass.NW": "북서",
  "compass.NW_long": "북서",
  "compass.S": "남",
  "compass.S_long": "남쪽",
  "compass.SE": "남동",
  "compass.SE_long": "남동",
  "compass.SSE": "남남동",
  "compass.SSE_long": "남남동",
  "compass.SSW": "남남서",
  "compass.SSW_long": "남남서",
  "compass.SW": "남서",
  "compass.SW_long": "남서",
  "compass.W": "서",
  "compass.W_long": "서쪽",
  "compass.WNW": "서북서",
  "compass.WNW_long": "서북서",
  "compass.WSW": "서남서",
  "compass.WSW_long": "서남서",
  "dashboard.currentObservations": "현재 관측",
  "dashboard.currentRainEvent": "현재 강우 이벤트",
  "dashboard.currentWeatherConditions": "현재 날씨",
  "dashboard.customizeDashboard": "사용자 지정",
  "dashboard.customizeDashboardDescription": "항목을 드래그하여 대시보드를 재정렬하세요. 눈 아이콘을 탭하여 섹션을 표시하거나 숨기세요.",
  "dashboard.dashboard": "대시보드",
  "dashboard.dayRangeExpected": "{time} {value} 예상",
  "dashboard.dayRangeReached": "{time} {value}",
  "dashboard.dayRangeSteady": "하루 종일 {value} 유지",
  "dashboard.hiddenSensors": "숨겨진 센서",
  "dashboard.hideSensor": "{sensor} 숨기기",
  "dashboard.lastRainEvent": "마지막 강우 이벤트",
  "dashboard.lastVisibleSensor": "센서를 하나 이상 표시해야 합니다.",
  "dashboard.manageSensors": "센서 관리",
  "dashboard.manageSensorsDescription": "항목을 드래그하여 센서 순서를 변경하세요. 눈 아이콘을 탭하여 센서를 표시하거나 숨기세요. 이름을 탭하여 변경하세요.",
  "dashboard.manageSensorsDescriptionWeb": "연필을 클릭하면 센서 이름을 바꾸고, 핸들을 끌면 목록 순서를 바꾸고, 눈을 클릭하면 숨기거나 표시합니다.",
  "dashboard.moveSensor": "{sensor} 이동",
  "dashboard.pressureSummary": "기압 요약",
  "dashboard.rainEvents": "강우 이벤트",
  "dashboard.rainSummary": "비 개요",
  "dashboard.renameSensor": "{sensor} 이름 변경",
  "dashboard.shareOutdoorMeasures": "실외 측정값을 공유하세요",
  "dashboard.shareOutdoorMeasuresDescription": "실외 측정값을 다른 사람들에게 공개하여 SmartMixin 커뮤니티에 참여하세요. 실내 측정값은 절대 공유되지 않습니다.",
  "dashboard.showSensor": "{sensor} 표시",
  "dashboard.temperatureSummary": "온도 요약",
  "dashboard.useDefaultSensorName": "기본 이름 사용",
  "dashboard.windSummary": "바람 개요",
  "devices.batteryLevel": "배터리 잔량",
  "devices.firmwareVersion": "펌웨어 버전",
  "devices.moduleCount": "{count, plural, other {모듈 #개}}",
  "devices.moduleType": "모듈 유형",
  "devices.noNetatmoWeatherStationYet": "아직 Netatmo 기상 관측소가 없습니다.",
  "devices.noOutdoorModule": "이 스테이션에는 작동하는 실외 모듈이 없습니다.",
  "devices.notReachable": "연결할 수 없음",
  "devices.serialNumber": "일련번호",
  "devices.signalAverage": "보통",
  "devices.signalBad": "약함",
  "devices.signalGood": "좋음",
  "devices.signalStrength": "신호 강도",
  "devices.signalUnknown": "알 수 없음",
  "devices.visitNetatmoWebsite": "Netatmo 웹사이트 방문",
  "devices.wifiStrength": "Wi-Fi 강도",
  "forecastMaps.addColor": "색상 추가",
  "forecastMaps.addLayer": "레이어 추가",
  "forecastMaps.autoDescription": "이 화면에 가장 적합한 모델",
  "forecastMaps.autoDescriptionFree": "무료 계정은 {model} 사용",
  "forecastMaps.autoPreview": "자동",
  "forecastMaps.autoSwitched": "현재 {model} 표시 중: {previous}은(는) 이 화면의 {coverage, number, percent} 포함",
  "forecastMaps.backToMaps": "지도 목록으로",
  "forecastMaps.build": "생성",
  "forecastMaps.buildCompleted": "생성 완료",
  "forecastMaps.builderMetaDescription": "기상 모델 레이어로 나만의 예보 지도를 만들어 보세요.",
  "forecastMaps.builderTitle": "지도 빌더",
  "forecastMaps.buildFailed": "생성에 실패했습니다. 다시 시도해 주세요.",
  "forecastMaps.buildNotPossible": "이 지도는 아직 생성할 수 없습니다 — 사용 가능한 예보 데이터가 없습니다.",
  "forecastMaps.buildProgress": "렌더링 중… {completed}/{total} 단계",
  "forecastMaps.buildStarting": "생성 시작 중…",
  "forecastMaps.byModel": "모델별",
  "forecastMaps.byZone": "지역별",
  "forecastMaps.colormap": "컬러맵",
  "forecastMaps.colormapCustom": "사용자 지정 색상",
  "forecastMaps.colormapGroupDomain": "기상 프리셋",
  "forecastMaps.colormapGroupMatplotlib": "과학 프리셋",
  "forecastMaps.colorStop": "색상 {position}",
  "forecastMaps.configUnavailable": "이 예보 지도는 사용할 수 없습니다. 대신 {name} 지도를 표시합니다.",
  "forecastMaps.contourLevels": "등치선 레벨",
  "forecastMaps.countryCanada": "캐나다",
  "forecastMaps.countryFrance": "프랑스",
  "forecastMaps.countryGermany": "독일",
  "forecastMaps.countryItaly": "이탈리아",
  "forecastMaps.countryScandinavia": "스칸디나비아",
  "forecastMaps.countrySpain": "스페인",
  "forecastMaps.countrySwitzerland": "스위스",
  "forecastMaps.countryUnitedStates": "미국",
  "forecastMaps.coverageUnknown": "지역 정보 없음",
  "forecastMaps.coversView": "이 화면의 {coverage, number, percent} 포함",
  "forecastMaps.customColormapMinColors": "사용자 지정 컬러맵에는 최소 두 가지 색상이 필요합니다",
  "forecastMaps.customExtent": "사용자 지정 범위",
  "forecastMaps.displayName": "표시 이름",
  "forecastMaps.downscaling": "바람 깃 간격 계수",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "영역 그리기",
  "forecastMaps.east": "동",
  "forecastMaps.extentDrawHint": "지도를 드래그하여 영역을 그리세요",
  "forecastMaps.extentInvalid": "서쪽은 동쪽보다 작아야 하고 남쪽은 북쪽보다 작아야 합니다",
  "forecastMaps.frameTime": "예보 시각",
  "forecastMaps.height": "높이(인치)",
  "forecastMaps.hourOffset": "+{hour}시간",
  "forecastMaps.inThisArea": "이 지역",
  "forecastMaps.invalidHexColor": "잘못된 색상 — #RRGGBB 형식을 사용하세요",
  "forecastMaps.layerHasErrors": "이 레이어에 오류가 있습니다",
  "forecastMaps.layers": "레이어",
  "forecastMaps.layerTypeBarbs": "바람 깃",
  "forecastMaps.layerTypeContour": "등치선",
  "forecastMaps.layerTypeFilledContour": "채워진 등치선",
  "forecastMaps.layerTypeMagnitude": "크기",
  "forecastMaps.layerTypeRaster": "래스터",
  "forecastMaps.layerTypeVectorField": "벡터장",
  "forecastMaps.leave": "나가기",
  "forecastMaps.levelsCount": "개수",
  "forecastMaps.levelsInvalid": "잘못된 등치선 레벨",
  "forecastMaps.levelsModeArange": "고정 간격",
  "forecastMaps.levelsModeExplicit": "직접 입력 값",
  "forecastMaps.levelsModeLinspace": "균등 분할(개수)",
  "forecastMaps.levelsStep": "간격",
  "forecastMaps.levelsValues": "값",
  "forecastMaps.levelsValuesHint": "쉼표로 구분, 오름차순",
  "forecastMaps.loadingMaps": "지도를 불러오는 중…",
  "forecastMaps.localTimeHint": "현지 시간으로 표시",
  "forecastMaps.lockedConfig": "{model}은(는) 프리미엄 모델입니다. 대신 {fallback}을(를) 표시합니다.",
  "forecastMaps.lockedVariable": "{variable}, 프리미엄",
  "forecastMaps.mapDescription": "설명",
  "forecastMaps.mapName": "지도 이름",
  "forecastMaps.mapNameRequired": "이름을 입력하세요",
  "forecastMaps.mapSettings": "지도 설정",
  "forecastMaps.maxLayersReached": "이 지도는 최대 {max}개의 레이어에 도달했습니다.",
  "forecastMaps.maxValue": "최댓값",
  "forecastMaps.memoryBudgetExceeded": "해상도가 렌더링 한도를 초과합니다 — DPI 또는 높이를 줄이세요",
  "forecastMaps.memoryBudgetUsage": "렌더링 한도: {percent}%",
  "forecastMaps.metaDescription": "기상 모델 실행 결과로 생성된 애니메이션 예보 지도.",
  "forecastMaps.metric": "기상 요소",
  "forecastMaps.metricRequired": "기상 요소를 선택하세요",
  "forecastMaps.metricUnavailable": "이 모델에서는 사용할 수 없습니다",
  "forecastMaps.minBelowMax": "최솟값은 최댓값보다 작아야 합니다",
  "forecastMaps.minMaxRequired": "이 레이어 유형에는 최솟값과 최댓값이 필요합니다",
  "forecastMaps.minValue": "최솟값",
  "forecastMaps.modelChipAuto": "자동 · {model}",
  "forecastMaps.modelCoversView": "{model}은(는) 이 화면의 {coverage, number, percent} 포함",
  "forecastMaps.modelNoRun": "아직 완료된 실행이 없습니다",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "아래로 이동",
  "forecastMaps.moveLayerUp": "위로 이동",
  "forecastMaps.nanClipToMin": "최솟값으로 제한",
  "forecastMaps.nanMask": "마스크",
  "forecastMaps.nanPolicy": "누락된 데이터",
  "forecastMaps.nanSkip": "건너뛰기",
  "forecastMaps.noCompletedRun": "이 지도는 아직 생성되지 않았습니다. 잠시 후 다시 확인해 주세요.",
  "forecastMaps.noLayers": "아직 레이어가 없습니다. 레이어를 추가해 시작하세요.",
  "forecastMaps.noMapsAvailable": "아직 사용할 수 있는 예보 지도가 없습니다.",
  "forecastMaps.north": "북",
  "forecastMaps.opacity": "불투명도",
  "forecastMaps.openAsAnimation": "애니메이션으로 열기",
  "forecastMaps.otherAreas": "다른 지역",
  "forecastMaps.outsideArea": "이 지역을 포함하지 않음",
  "forecastMaps.overlayLegend": "범례",
  "forecastMaps.pause": "일시정지",
  "forecastMaps.play": "재생",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "이 지점의 예보를 불러오지 못했습니다.",
  "forecastMaps.pointValueLoading": "예보를 불러오는 중…",
  "forecastMaps.pointValueUnavailable": "이 시간의 데이터가 없습니다.",
  "forecastMaps.premiumModelForView": "{model}은(는) 이 화면을 포함",
  "forecastMaps.premiumRequired": "예보 지도에는 프리미엄이 필요합니다",
  "forecastMaps.preview": "미리보기",
  "forecastMaps.previewEmptyHint": "미리보기를 렌더링하려면 유효한 레이어를 하나 이상 설정하세요.",
  "forecastMaps.previewFailed": "미리보기에 실패했습니다",
  "forecastMaps.previewHour": "예보 시각",
  "forecastMaps.previewRendering": "미리보기 렌더링 중…",
  "forecastMaps.projection": "투영법",
  "forecastMaps.projectionLambertConformal": "람베르트 정각원추",
  "forecastMaps.projectionMercator": "메르카토르",
  "forecastMaps.projectionPlateCarree": "정거원통(Plate carrée)",
  "forecastMaps.projectionStereographic": "평사도법",
  "forecastMaps.regionEurope": "유럽",
  "forecastMaps.regionNorthAmerica": "북아메리카",
  "forecastMaps.removeColor": "색상 제거",
  "forecastMaps.removeLayer": "레이어 제거",
  "forecastMaps.retry": "다시 시도",
  "forecastMaps.run": "실행: {run}",
  "forecastMaps.runNotDisplayable": "이 실행 결과는 대화형 지도에 표시할 수 없습니다.",
  "forecastMaps.save": "저장",
  "forecastMaps.selectExtentOnMap": "지도에서 영역 선택",
  "forecastMaps.showArea": "지역 보기",
  "forecastMaps.showAreaOf": "지역 보기, {model}",
  "forecastMaps.south": "남",
  "forecastMaps.switchToModel": "{model}(으)로 전환",
  "forecastMaps.title": "예보 지도",
  "forecastMaps.uMetric": "U 성분",
  "forecastMaps.unitConversion": "단위 변환",
  "forecastMaps.unitNone": "없음",
  "forecastMaps.unsavedChangesBody": "저장되지 않은 변경 사항이 있습니다. 나가서 변경 사항을 버릴까요?",
  "forecastMaps.unsavedChangesTitle": "저장되지 않은 변경 사항",
  "forecastMaps.useCurrentView": "현재 화면 사용",
  "forecastMaps.useModelDomain": "꺼짐: 모델의 전체 영역을 사용합니다",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U와 V 기상 요소는 서로 달라야 합니다",
  "forecastMaps.valueAtMapCentre": "지도 중심의 값",
  "forecastMaps.valueBetween": "{min}에서 {max} 사이여야 합니다",
  "forecastMaps.variable": "변수",
  "forecastMaps.variableMissing": "{variable} 사용 불가",
  "forecastMaps.variableOnlyFrom": "{variable}은(는) {model}에서만 제공",
  "forecastMaps.viewMap": "지도 보기",
  "forecastMaps.vMetric": "V 성분",
  "forecastMaps.west": "서",
  "forecastMaps.windAnimation": "바람 애니메이션",
  "forecastModels.addForecastModel": "모델 추가",
  "forecastModels.atYourStations": "내 관측소에서 사용 가능",
  "forecastModels.comparisonLoadError": "예보 모델 비교를 불러오지 못했습니다",
  "forecastModels.coverageLoading": "각 모델이 어느 관측소를 포함하는지 계산 중…",
  "forecastModels.description_AROME": "서유럽 상공의 대류 분해 가능 고해상도 Météo France 모델, 해상도 1.3km. 프랑스의 단기 예보에서 동급 최고; 3시간마다 업데이트.",
  "forecastModels.description_ARPEGE_EU": "해상도 10km의 Météo France ARPEGE 모델의 유럽 둥지 격자. 유럽 상공의 중기 예보, 하루 네 번 업데이트.",
  "forecastModels.description_ARPEGE_GLOBAL": "해상도 25km의 Météo France 전 지구 수치 일기 예보 모델, 약 4일까지 실행. 하루 네 번 업데이트.",
  "forecastModels.description_DMI_DINI": "DMI의 HARMONIE DINI: 북서 유럽(덴마크, 베네룩스, 아일랜드, 영국, 스칸디나비아) 상공의 대류 허용 모델로 해상도 2km, 60시간까지 실행, 하루 여덟 번 업데이트. 수정된 DMI 오픈 데이터(CC BY 4.0)를 포함합니다.",
  "forecastModels.description_EC_GDPS": "Environment Canada의 Global Deterministic Prediction System(전 지구 결정론적 예측 시스템): 해상도 15km의 전 세계 중기 모델, 10일까지 실행, 하루 두 번 업데이트.",
  "forecastModels.description_EC_HRDPS": "Environment Canada의 High Resolution Deterministic Prediction System(고해상도 결정론적 예측 시스템): 캐나다와 미국 북부 상공의 대류 허용 모델로 해상도 2.5km, 48시간까지 실행, 하루 네 번 업데이트.",
  "forecastModels.description_EC_RDPS": "Environment Canada의 Regional Deterministic Prediction System(지역 결정론적 예측 시스템): 해상도 10km의 북미 상공 중기 모델, 하루 네 번 업데이트.",
  "forecastModels.description_ECMWF_HRES": "유럽중기예보센터(ECMWF)의 주력 고해상도 모델(IFS)로, 세계 최고의 글로벌 예보 시스템으로 널리 인정받고 있습니다. 지구 전체를 25km 해상도로 최대 15일까지 커버하며 하루 4회 업데이트됩니다. 수정된 ECMWF 오픈 데이터(CC BY 4.0)를 포함합니다.",
  "forecastModels.description_GFS": "NOAA의 주력 중기 전 지구 모델. 해상도 25km로 전체 지구를 16일까지 다루며, 하루 네 번 업데이트.",
  "forecastModels.description_HRRR_CONUS": "NOAA의 High-Resolution Rapid Refresh: 미국 본토 상공의 해상도 3km 대류 분해 가능 모델, 매시간 업데이트. 뇌우와 악기상의 매우 단기 예보에 가장 적합.",
  "forecastModels.description_ICON": "DWD의 전 지구 ICON 모델. 13 km 해상도로 지구 전체를 7.5일까지 커버하며 하루 네 번 갱신됩니다. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteo가 ARPAE와 공동 운영하는 ICON-2I: 이탈리아 상공의 대류 허용 모델로 해상도 2.2km, 72시간까지 실행, 하루 두 번 업데이트. ItaliaMeteo 오픈 데이터(CC BY 4.0)를 포함합니다.",
  "forecastModels.description_ICON_CH1": "MeteoSwiss의 ICON-CH1-EPS 컨트롤 런: 알프스 상공의 대류 허용 모델로 해상도 1km, 33시간까지 실행, 세 시간마다 업데이트.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss의 ICON-CH2-EPS 컨트롤 런: 알프스(스위스와 주변 알프스 지역) 상공의 대류 허용 모델로 해상도 2.1km, 120시간까지 실행, 하루 네 번 업데이트.",
  "forecastModels.description_ICON_DE": "독일과 주변 국가 상공의 해상도 2.2km 대류 분해 가능 고해상도 DWD 모델. 단기 예보는 하루 두 번 업데이트. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "해상도 7km의 DWD ICON 모델 유럽 둥지 격자로 유럽과 북대서양을 다룸. 중기 예보는 하루 네 번 업데이트. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "노르웨이 기상 연구소의 오픈 일기 예보 서비스로, 고해상도 북유럽 모델과 ECMWF 데이터를 결합하여 최대 10일 앞의 전 세계 예보를 제공.",
  "forecastModels.description_MF_AROME_ANTILLES": "프랑스령 앤틸리스 제도(과들루프, 마르티니크) 상공의 해상도 2.5km AROME 둥지 격자. 단기 예보는 하루 네 번 업데이트.",
  "forecastModels.description_MF_AROME_GUYANE": "프랑스령 기아나 상공의 해상도 2.5km AROME 둥지 격자. 단기 예보는 하루 네 번 업데이트.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "뉴칼레도니아 상공의 해상도 2.5km AROME 둥지 격자. 단기 예보는 하루 네 번 업데이트.",
  "forecastModels.description_MF_AROME_POLYNESIE": "프랑스령 폴리네시아 상공의 해상도 2.5km AROME 둥지 격자. 단기 예보는 하루 네 번 업데이트.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "레위니옹과 마요트 상공의 해상도 2.5km AROME 둥지 격자. 단기 예보는 하루 네 번 업데이트.",
  "forecastModels.description_RRFS_CONUS": "미국 본토를 3km 해상도로 다루는 NOAA의 Rapid Refresh Forecast 시스템. 시간별 예보를 하루 8회 갱신하며, 주요 4회는 84시간까지, 나머지는 18시간까지 제공합니다.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "북미 전역을 13km 해상도로 다루는 NOAA의 Rapid Refresh Forecast 시스템. 84시간까지 시간별 예보를 하루 4회 갱신합니다.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixin의 주력 예보. 귀하의 위치의 매시간에 대해 사용 가능한 최고의 모델을 선택합니다 — 일반적으로 존재하는 곳에서는 고해상도 지역 모델(프랑스의 AROME, 독일의 ICON-D2, 미국의 HRRR, 대륙 전체의 ARPEGE Europe…)이며 다른 곳에서는 전 지구 모델로 되돌아갑니다 — 그런 다음 인접한 소스에서 격차를 메웁니다. 그 결과는 세계 어디에서나 14일까지 다루는 단일하고 매끄러운 예보이며, 기본 모델 중 하나가 업데이트될 때마다 자동으로 새로 고쳐집니다.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflow의 독점적인 전 지구 예보로, 여러 수치 일기 예보 모델과 Tempest 기상 관측소 네트워크의 관측을 결합합니다. 전 세계 10일 예보 기간.",
  "forecastModels.everywhereElse": "그 밖의 모든 곳",
  "forecastModels.everywhereElseFoot": "선호 모델이 닿지 않는 모든 관측소에서 사용됩니다.",
  "forecastModels.everywhereElsePick": "하나 선택",
  "forecastModels.fallbackBlend": "SmartMixin 혼합",
  "forecastModels.fallbackBlendSub": "여러 모델을 각각 가장 강한 곳에서 결합합니다.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES가 닿는 모든 곳에서 사용합니다.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA의 전 지구 모델. 현재 모든 계정이 사용하는 모델입니다.",
  "forecastModels.fallbackResolution": "최고 해상도",
  "forecastModels.fallbackResolutionSub": "각 관측소에서 사용할 수 있는 가장 조밀한 격자.",
  "forecastModels.forecastChipLabelWithRun": "{model}, 실행 {run}",
  "forecastModels.forecastChipRunHint": "길게 눌러 최신 실행 표시 또는 숨기기",
  "forecastModels.forecastComparisonDescription": "여러 소스의 예보 모델 결과를 쉽게 비교",
  "forecastModels.forecastFollowingPreferences": "설정을 따르는 중",
  "forecastModels.forecastLoadError": "예보를 불러오지 못했습니다",
  "forecastModels.forecastModel": "예보 모델",
  "forecastModels.forecastModelAbout": "{model} 정보",
  "forecastModels.forecastModelComparison": "예보 모델 비교",
  "forecastModels.forecastModelCoverage": "적용 범위",
  "forecastModels.forecastModelDescription": "설명",
  "forecastModels.forecastModels": "예보 모델",
  "forecastModels.forecastModelScopeGlobal": "전 지구",
  "forecastModels.forecastModelScopeGlobalDescription": "이 모델은 전 지구를 다룹니다.",
  "forecastModels.forecastModelScopeRegional": "지역",
  "forecastModels.forecastModelScopeRegionalDescription": "이 모델은 특정 지역만 다룹니다.",
  "forecastModels.forecastModelSpecifications": "사양",
  "forecastModels.forecastNoPinLocation": "이 위치에 닿는 선호 모델이 없습니다 — ‘그 밖의 모든 곳’이 결정합니다.",
  "forecastModels.forecastNoPinStation": "이 관측소에 닿는 선호 모델이 없습니다 — ‘그 밖의 모든 곳’이 결정합니다.",
  "forecastModels.forecastNoPreferredModels": "아직 설정된 선호 모델이 없습니다.",
  "forecastModels.forecastOverrideElsewhere": "설정은 그 밖의 모든 곳에 적용됩니다.",
  "forecastModels.forecastPickForLocation": "또는 이 위치용으로 선택",
  "forecastModels.forecastPickForStation": "또는 이 관측소용으로 선택",
  "forecastModels.forecastPinWinsLocation": "{model} — 이 위치에 닿는 첫 번째 선호 모델입니다.",
  "forecastModels.forecastPinWinsStation": "{model} — 이 관측소에 닿는 첫 번째 선호 모델입니다.",
  "forecastModels.forecastServedNowHere": "현재 여기서는 {model}입니다",
  "forecastModels.forecastSetForLocation": "이 위치에 설정됨",
  "forecastModels.forecastSetForStation": "이 관측소에 설정됨",
  "forecastModels.forecastSettingsRowSub": "선호 모델과 그 밖의 모든 곳에 적용되는 설정",
  "forecastModels.forecastStopUsingHere": "여기서 사용 중지",
  "forecastModels.forecastUseForLocation": "이 위치에 {model} 사용",
  "forecastModels.forecastUseForStation": "이 관측소에 {model} 사용",
  "forecastModels.forecastUsePreferred": "내 선호 모델 사용",
  "forecastModels.frequencyHourly": "매시간",
  "forecastModels.horizon": "예보 기간",
  "forecastModels.horizonValue": "최대 {value} 시간",
  "forecastModels.meshSize": "그리드 크기",
  "forecastModels.pickerShowAll": "전체 카탈로그 표시",
  "forecastModels.pickerUnreachable": "{count, plural, other {다른 모델 #개}}는 어느 관측소에도 닿지 않습니다",
  "forecastModels.pinInUse": "사용 중",
  "forecastModels.pinShadowed": "사용되지 않음 — 위의 모델이 모든 관측소를 포함합니다",
  "forecastModels.pinSlots": "{max}개 중 {used}개 · 모델 선택",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {하나뿐인 슬롯이 사용 중입니다. 다른 모델을 추가하려면 해당 모델을 제거하세요.} other {#개 슬롯을 모두 사용했습니다. 추가하려면 하나를 제거하세요.}}",
  "forecastModels.pinsUncoveredCount": "{count, plural, other {# 개}} 중 {used} 개 관측소: 선호 모델이 닿지 않습니다 — ‘그 밖의 모든 곳’이 결정합니다.",
  "forecastModels.pinsUncoveredNamed": "{stations}: {count, plural, other {선호 모델이 닿지 않습니다}} — ‘그 밖의 모든 곳’이 결정합니다.",
  "forecastModels.pinUnreachable": "사용되지 않음 — 어느 관측소에도 닿지 않습니다",
  "forecastModels.pinUsedAt": "{stations}에서 사용",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {내 관측소에서 사용} other {# 개 관측소 모두에서 사용}}",
  "forecastModels.pinUsedAtSome": "{count, plural, other {# 개}} 중 {used} 개 관측소에서 사용",
  "forecastModels.preferredModels": "선호 모델",
  "forecastModels.preferredModelsAll": "하나의 목록, 모든 관측소",
  "forecastModels.preferredModelsOne": "하나의 목록, 어디에나 적용",
  "forecastModels.publisher": "제공 기관",
  "forecastModels.removePreferredModel": "{model}을(를) 선호 모델에서 제거",
  "forecastModels.resetForecastPreference": "초기화",
  "forecastModels.resetForecastPreferenceHint": "선호 모델을 지우고 SmartMixin 기본값으로 되돌립니다.",
  "forecastModels.servedNowMany": "현재: {count, plural, =1 {내 관측소} other {# 개 관측소 모두}}에서 GFS.",
  "forecastModels.servedNowNone": "현재: 어디서나 GFS.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin 멀티 모델",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow 예보",
  "forecastModels.weatherForecastModels": "일기예보 모델",
  "helpCenter.articleCount": "{count}개의 문서",
  "helpCenter.articleNotFound": "문서를 찾을 수 없음",
  "helpCenter.articleNotFoundDescription": "찾고 있는 문서가 존재하지 않습니다.",
  "helpCenter.backToHelpCenter": "도움말 센터로 돌아가기",
  "helpCenter.browseByCategory": "카테고리별 탐색",
  "helpCenter.categoryNotFound": "카테고리를 찾을 수 없습니다",
  "helpCenter.categoryNotFoundDescription": "이 카테고리가 존재하지 않거나 문서가 없습니다.",
  "helpCenter.contactSupport": "지원팀에 문의",
  "helpCenter.feedbackHelpsImprove": "여러분의 의견은 도움말 문서 개선에 사용됩니다.",
  "helpCenter.feedbackReasonNotAnswer": "제 질문에 대한 답이 아닙니다",
  "helpCenter.feedbackReasonOutdated": "정보가 오래되었습니다",
  "helpCenter.feedbackReasonUnclear": "설명이 명확하지 않습니다",
  "helpCenter.feedbackWhatWentWrong": "어떤 문제가 있었나요?",
  "helpCenter.helpCategoryAccount": "계정",
  "helpCenter.helpCategoryBilling": "결제",
  "helpCenter.helpCategoryForecast": "예보",
  "helpCenter.helpCategoryGettingStarted": "시작하기",
  "helpCenter.helpCategoryProviders": "프로바이더",
  "helpCenter.helpCategoryStations": "관측소",
  "helpCenter.helpCategoryTroubleshooting": "문제 해결",
  "helpCenter.helpCenter": "도움말 센터",
  "helpCenter.landingDescription": "자주 묻는 질문에 대한 답변을 찾고 SmartMixin을 최대한 활용하는 방법을 알아보세요.",
  "helpCenter.linkToSection": "이 섹션으로 연결되는 링크",
  "helpCenter.menuItemDescription": "FAQ 및 가이드",
  "helpCenter.minRead": "{minutes}분 읽기",
  "helpCenter.onThisPage": "이 페이지에서",
  "helpCenter.platformMobileApp": "모바일 앱",
  "helpCenter.platformMobileOnly": "모바일 앱 전용",
  "helpCenter.platformWebApp": "웹 앱",
  "helpCenter.platformWebOnly": "웹 앱 전용",
  "helpCenter.popularArticles": "인기 문서",
  "helpCenter.relatedArticles": "관련 문서",
  "helpCenter.searchArticles": "문서 검색...",
  "helpCenter.stillNeedHelp": "여전히 도움이 필요하신가요?",
  "helpCenter.stillNeedHelpDescription": "이 문서로 문제가 해결되지 않았다면 직접 도와드리겠습니다.",
  "helpCenter.supportEmailSubject": "SmartMixin 도움말",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin 도움말 — {topic}",
  "helpCenter.thankYouForFeedback": "피드백을 주셔서 감사합니다!",
  "helpCenter.wasArticleHelpful": "이 문서가 도움이 되셨나요?",
  "intro.locationDescription": "정확한 지역 기반 예보를 위해 위치 접근을 허용해 주세요 — 더 이상 일반적인 예보는 없습니다.",
  "intro.locationTitle": "당신을 위한 맞춤형 예보",
  "intro.notificationDescription": "비, 눈 또는 심각한 기상 상황에 대해 실시간으로 알림을 받아보세요. 필요한 순간에 정확히 알려드립니다.",
  "intro.notificationsTitle": "날씨 변화를 놓치지 마세요",
  "intro.readyDescription": "정확한 예보, 실시간 날씨 정보, 그리고 전 세계 기상 관측소 데이터를 하나의 강력한 앱에서 만나보세요.",
  "intro.readyTitle": "모든 준비 완료!",
  "intro.welcomeDescription": "최고의 기상 기관들이 제공하는 초지역 날씨 예보와 함께, 전 세계 40,000개 이상의 기상 관측소에서 실제 과거 및 현재의 날씨를 확인할 수 있어요.",
  "intro.welcomeTitle": "당신만의 날씨, 새롭게 정의하다",
  "landing.alsoAvailableOn": "다음에서도 이용 가능:",
  "landing.featureAlertsDescription": "모든 지표에 맞춤 임계값을 설정하세요. 기온이 떨어지거나, 비가 내리기 시작하거나, 바람이 강해지면 알림을 받을 수 있습니다.",
  "landing.featureAlertsTitle": "스마트 알림",
  "landing.featureAnalyticsDescription": "대화형 차트, 트렌드 분석, 상세한 통계. 기온, 습도, 기압, 비, 바람 데이터를 깊이 있게 살펴보세요.",
  "landing.featureAnalyticsTitle": "고급 분석",
  "landing.featureExportDescription": "모든 날씨 데이터를 Excel 스프레드시트로 이메일로 받아 Excel, Google 스프레드시트 또는 즐겨 쓰는 도구에서 더 자세히 분석하세요.",
  "landing.featureExportTitle": "데이터 내보내기",
  "landing.featureForecastDescription": "ECMWF, GFS, 지역 모델을 포함한 {count, plural, other {#개 이상의 전문 예보 모델}}을 이용하세요. 나란히 비교하며 나만의 예측을 세워 보세요.",
  "landing.featureForecastTitle": "예보 모델 비교",
  "landing.featureHistoryDescription": "시간별, 일별, 월별 스케일의 과거 데이터에 접근하세요. 연구나 개인 보관용으로 Excel로 내보낼 수 있습니다.",
  "landing.featureHistoryTitle": "풍부한 기록",
  "landing.featureMultiBrandDescription": "Netatmo, Davis, Tempest, Ecowitt, Ambient Weather 등을 연결하세요. 더 이상 앱을 오갈 필요가 없습니다.",
  "landing.featureMultiBrandTitle": "모든 브랜드를 하나의 앱에서",
  "landing.featuresSubtitle": "SmartMixin은 날씨 데이터를 전문가처럼 분석하고, 비교하고, 이해할 수 있는 도구를 제공합니다.",
  "landing.featuresTitle": "데이터를 사랑하는 분들을 위해",
  "landing.finalCtaButton": "무료 계정 만들기",
  "landing.finalCtaSubtitle": "SmartMixin을 신뢰하는 수천 명의 날씨 애호가와 함께하세요.",
  "landing.finalCtaTitle": "날씨 데이터를 더 깊이 살펴볼 준비가 되셨나요?",
  "landing.heroCta": "무료로 시작",
  "landing.heroDescription": "심층 분석, 아름다운 차트, 전문가 수준의 예보 — 모든 기상 관측소를 하나의 강력한 앱으로.",
  "landing.heroSecondaryCta": "지도 살펴보기",
  "landing.heroTagline": "날씨 애호가를 위한",
  "landing.heroTitle": "지금껏 본 적 없는 방식으로 날씨를 확인하세요",
  "landing.pricingComparisonCaption": "무료 플랜과 프리미엄 기능 비교",
  "landing.pricingFeatureAdvancedMetrics": "고급 지표",
  "landing.pricingFeatureAlerts": "맞춤 알림",
  "landing.pricingFeatureColumn": "기능",
  "landing.pricingFeatureExport": "데이터 내보내기 (Excel)",
  "landing.pricingFeatureForecastComparison": "예보 비교",
  "landing.pricingFeatureForecasts": "예보 모델",
  "landing.pricingFeatureForecastsFreeTier": "1개 모델",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, other {#개 이상의 모델}}",
  "landing.pricingFeatureReports": "분석 및 보고서",
  "landing.pricingFeatureStationComparison": "관측소 비교",
  "landing.pricingFeatureWidgets": "홈 화면 위젯",
  "landing.pricingFeatureYearOverYear": "전년 대비 분석",
  "landing.pricingFreeCta": "시작하기",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "가장 인기",
  "landing.pricingPremiumCta": "시작하기",
  "landing.pricingPremiumDescription": "월 1.99€부터 — 웹, App Store 또는 Google Play에서 구독",
  "landing.pricingSubtitle": "무료로 시작하고, 더 필요할 때 업그레이드하세요.",
  "landing.pricingTitle": "간단하고 투명한 가격",
  "landing.statBrands": "지원 브랜드",
  "landing.statForecasts": "예보 모델",
  "landing.statStations": "기상 관측소",
  "landing.supportedDevicesNote": "여기에 세계기상기구 네트워크의 공공 관측소 {count, number}개 이상",
  "landing.supportedDevicesSubtitle": "사용 중인 기상 관측소를 몇 분 만에 연결하세요. {count, plural, other {#개 주요 브랜드}}를 지원하며 계속 늘어나고 있습니다.",
  "landing.supportedDevicesTitle": "사용 중인 관측소와 호환",
  "metrics.absolutePressure": "절대 기압",
  "metrics.airDensity": "공기 밀도",
  "metrics.airGap": "에어 갭",
  "metrics.apparentTemperature": "겉보기 온도",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "평균",
  "metrics.avg_wind": "평균 풍속",
  "metrics.beaufort": "보퍼트",
  "metrics.blackGlobeTemperature": "흑구 온도",
  "metrics.boilerOn": "보일러 ON",
  "metrics.boilerOnInHours": "보일러 ON (시간)",
  "metrics.cloudCover": "운량",
  "metrics.co2": "CO2",
  "metrics.conductivity": "전도도",
  "metrics.dailyPrecipitation": "일 강수량",
  "metrics.dailyRain": "일일 강우량",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "깊이",
  "metrics.depthSensors": "깊이 센서",
  "metrics.dewPoint": "이슬점",
  "metrics.distance": "거리",
  "metrics.downTrend": "하락",
  "metrics.ET": "증발산",
  "metrics.etToday": "오늘 증발산",
  "metrics.feelsLike": "체감 온도",
  "metrics.feelsLikeWithFormula": "체감 온도 ({formula})",
  "metrics.frostPoint": "서리점",
  "metrics.gust": "돌풍",
  "metrics.gustDirection": "돌풍 방향",
  "metrics.hail": "우박",
  "metrics.heatIndex": "열지수",
  "metrics.heatingDegreeDays": "난방도일",
  "metrics.heatingPower": "난방력",
  "metrics.humidex": "휴미덱스",
  "metrics.humidity": "습도",
  "metrics.lastLightningImpact": "마지막 낙뢰",
  "metrics.lastMeasure": "마지막 측정",
  "metrics.leafSensors": "나뭇잎 센서",
  "metrics.leafWetness": "잎의 젖음",
  "metrics.lightningDistance": "거리",
  "metrics.lightningStrikeCount": "낙뢰 횟수",
  "metrics.lightningStrikeDistance": "낙뢰 거리",
  "metrics.max": "최대",
  "metrics.max_gust": "최대 순간풍속",
  "metrics.maxToday": "오늘 최대",
  "metrics.min": "최소",
  "metrics.noise": "소음",
  "metrics.normalizedHeatingCoefficient": "표준화된 가열 계수",
  "metrics.outdoorTemperature": "실외 온도",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "강수량",
  "metrics.pressure": "기압",
  "metrics.rain": "비",
  "metrics.rainDurationValue": "강우 시간: {duration}",
  "metrics.rainfallMeasurement": "강우량 측정",
  "metrics.rainRate": "강수 강도",
  "metrics.relativePressure": "상대 기압",
  "metrics.setPoint": "설정값",
  "metrics.snow": "눈",
  "metrics.snowfall": "강설량",
  "metrics.soilMoisture": "수분",
  "metrics.soilSensors": "토양 센서",
  "metrics.soilWaterTension": "토양 수분 장력",
  "metrics.solarEnergy": "태양 에너지",
  "metrics.solarRadiation": "태양 복사",
  "metrics.speed": "속도",
  "metrics.stableTrend": "안정",
  "metrics.sum": "합계",
  "metrics.temperature": "온도",
  "metrics.temperatureSensors": "온도 및 습도 센서",
  "metrics.temperatureShort": "온도",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "상승",
  "metrics.uv": "자외선",
  "metrics.visibility": "가시거리",
  "metrics.weatherCondition": "날씨 상태",
  "metrics.wetBulbGlobeTemperature": "습구흑구온도",
  "metrics.wetBulbTemperature": "습구온도",
  "metrics.wind": "바람",
  "metrics.windChill": "풍속 냉각",
  "metrics.windDirection": "풍향",
  "metrics.windMeasurement": "바람 측정",
  "metrics.windRun": "윈드런",
  "metrics.windRunDescription": "윈드런은 일정 기간 동안 바람이 이동한 총 거리입니다",
  "metrics.windSpeed": "풍속",
  "navigation.allFavorites": "모두 보기",
  "navigation.breadcrumbs": "탐색 경로",
  "navigation.collapseNavigation": "탐색 메뉴 접기",
  "navigation.expandNavigation": "탐색 메뉴 펼치기",
  "navigation.main": "메인",
  "navigation.mapShort": "지도",
  "navigation.skipToContent": "본문 바로가기",
  "navigation.stationsShort": "관측소",
  "network.cancelError": "요청이 취소되었습니다",
  "network.connectionError": "서버를 사용할 수 없습니다",
  "network.networkError": "네트워크를 사용할 수 없음",
  "network.serverError": "문제가 발생했습니다.",
  "network.timeoutError": "접속 시간 초과",
  "network.unknownError": "알수없는 오류",
  "premium.alreadyPremium": "당신은 이미 프리미엄 계정을 가지고 있습니다!",
  "premium.bestValue": "가성비 최고",
  "premium.billingDetailsAndroid": "무료 체험: 체험 기간이 끝나기 최소 24시간 전에 취소하면 요금이 청구되지 않습니다. 이후 SmartMixin 구독은 현재 기간이 끝나기 최소 24시간 전에 취소하지 않는 한 자동으로 갱신되며, Google Play 계정 설정에서 언제든지 취소할 수 있습니다. 각 갱신 시 위 버튼에 표시된 가격이 청구됩니다. 결제 금액은 구매 확인 시와 각 갱신 기간이 시작될 때 Google Play 계정으로 청구됩니다.",
  "premium.billingDetailsIos": "무료 체험: 체험 기간이 끝나기 최소 24시간 전에 취소하면 요금이 청구되지 않습니다. 이후 SmartMixin 구독은 현재 기간이 끝나기 최소 24시간 전에 취소하지 않는 한 자동으로 갱신되며, App Store 계정 설정에서 언제든지 취소할 수 있습니다. 각 갱신 시 위 버튼에 표시된 가격이 청구됩니다. 결제 금액은 구매 확인 시와 각 갱신 기간이 시작될 때 App Store 계정으로 청구됩니다.",
  "premium.freeBannerBody": "무료 계정에는 어디서나 GFS가 제공됩니다. 선호 모델과 ‘그 밖의 모든 곳’은 구독하는 즉시 적용됩니다.",
  "premium.freeBannerTitle": "환경설정은 프리미엄에서 적용됩니다",
  "premium.freeSubscription": "무료 프리미엄 구독",
  "premium.freeTrialForPeriod": "{period, plural, other {#일}} 무료 체험",
  "premium.getUnlimitedAccess": "무제한 액세스:",
  "premium.manageMySubscription": "내 구독 관리",
  "premium.notPurchasedYet": "이 스토어 계정에서 SmartMixin 프리미엄 구매 내역을 찾을 수 없습니다.",
  "premium.orChooseMonthly": "또는 월간 선택:",
  "premium.premium": "SmartMixin 프리미엄",
  "premium.premiumActive": "활성",
  "premium.premiumAnnualTrialInfo": "{days, plural, other {#일}} 무료 체험으로 시작하세요",
  "premium.premiumCurrentPlan": "현재 플랜",
  "premium.premiumDownloadApp": "구독하려면 앱을 다운로드하세요:",
  "premium.premiumEndsOn": "{date}에 만료",
  "premium.premiumFeatureAlerts": "날씨 알림",
  "premium.premiumFeatureAnalysis": "고급 날씨 분석",
  "premium.premiumFeatureCharts": "차트 비교",
  "premium.premiumFeatureExport": "데이터 내보내기",
  "premium.premiumFeatureForecast": "지역 예보 모델",
  "premium.premiumFeatureNotification": "상태 표시줄 위젯",
  "premium.premiumFeatureTitle": "프리미엄 기능",
  "premium.premiumFeatureWidgets": "홈 화면 위젯",
  "premium.premiumFreePlan": "무료",
  "premium.premiumInactive": "미구독",
  "premium.premiumManageStoreSubscription": "{store}에서 구독하셨습니다. 구독 관리나 취소는 그곳에서 하세요.",
  "premium.premiumManageWebSubscription": "구독을 관리하고, 결제 수단을 업데이트하거나 취소하세요.",
  "premium.premiumPremiumPlan": "프리미엄",
  "premium.premiumRenewsOn": "{date}에 갱신",
  "premium.premiumSubscribeAnnual": "연간 — 9.99 €/년",
  "premium.premiumSubscribedOn": "{platform}에서 구독 중",
  "premium.premiumSubscribedOnWeb": "웹에서 구독 중",
  "premium.premiumSubscribeMonthly": "월간 — 1.99 €/월",
  "premium.premiumSubscribeOnWeb": "지금 구독하여 모든 프리미엄 기능을 잠금 해제하세요.",
  "premium.premiumSubscriptionSuccess": "구독이 활성화되었습니다! 모든 프리미엄 기능을 즐기세요.",
  "premium.premiumSubscriptionSuccessTitle": "프리미엄에 오신 것을 환영합니다!",
  "premium.premiumWebappNotice": "현재 웹에서는 구독할 수 없습니다.",
  "premium.pricePerMonth": "{price}/월",
  "premium.pricePerYear": "{price}/년",
  "premium.purchasedNetatmoPro": "이전에 Netatmo Pro({date})를 구매하셨습니다. 이를 통해 프리미엄 기능의 하위 집합에 액세스할 수 있습니다. 모든 프리미엄 기능에 액세스하려면 다음 혜택 중 하나를 구독하세요.",
  "premium.purchaseFailed": "구매를 완료할 수 없습니다. 다시 시도해 주세요.",
  "premium.restoreFailed": "구매 내역을 복원할 수 없습니다. 다시 시도해 주세요.",
  "premium.restorePurchase": "구매 복원",
  "premium.savingsPercent": "{percent}% 절약",
  "premium.seePremium": "프리미엄 보기",
  "premium.startFreeTrial": "무료 체험 시작",
  "premium.storeUnavailable": "지금은 스토어를 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
  "premium.subscribeNow": "지금 구독 — 체험 없음",
  "premium.switchToPremium": "SmartMixin 프리미엄으로 전환",
  "premium.thenPrice": "이후 {price}",
  "providerHints.ambientWeatherApiKey": "ambientweather.net 계정 설정에서 생성됩니다.",
  "providerHints.davisApiSecret": "V2 API 키를 만들 때 한 번만 표시됩니다 — 안전하게 보관하세요.",
  "providerHints.davisV2ApiKey": "weatherlink.com의 V2 API 키 페이지에서 가져옵니다.",
  "providerHints.ecowittApi": "Ecowitt 계정의 API 페이지에서 가져옵니다.",
  "providerHints.ecowittApp": "애플리케이션 키도 Ecowitt 계정에서 가져옵니다.",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite 계정의 이메일과 비밀번호를 사용하세요 — SmartMixin 로그인이 아닙니다.",
  "providerHints.myAcuriteEmail": "My AcuRite 계정의 이메일 — SmartMixin 로그인이 아닙니다.",
  "providerHints.myAcuritePassword": "My AcuRite 계정의 비밀번호.",
  "providerHints.weatherflowToken": "tempestwx.com → 설정 → 데이터 인증에서 가져오는 개인용 토큰.",
  "providerHints.wundergroundEditKey": "다른 키 사용",
  "providerHints.wundergroundKey": "Weather Underground 계정의 API 키 페이지에서 가져온 긴 문자열입니다 — wunderground.com 비밀번호가 아닙니다.",
  "providerHints.wundergroundKeyExample": "예: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API 키가 확인되었습니다",
  "providerHints.wundergroundNoStationsNearby": "이 위치 근처에서 스테이션을 찾을 수 없습니다. 스테이션 ID를 직접 입력해 보세요.",
  "providerHints.wundergroundStationIdExample": "예: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather API 키를 받으세요.",
  "providerIntro.davisStep2": "Davis V2 API 키와 API 시크릿을 받으세요.",
  "providerIntro.ecowittStep2": "Ecowitt API 키와 애플리케이션 키를 받으세요.",
  "providerIntro.getStarted": "시작하기",
  "providerIntro.myAcuriteStep2": "기존 My AcuRite 계정의 이메일과 비밀번호를 사용하세요.",
  "providerIntro.netatmoEnergyStep2": "요청이 있을 때 Netatmo에 로그인하세요 — API 키가 필요하지 않습니다.",
  "providerIntro.netatmoWeatherStep2": "요청이 있을 때 Netatmo에 로그인하세요 — API 키가 필요하지 않습니다.",
  "providerIntro.signupBanner": "거의 다 됐습니다 — {provider}를 연결하려면 무료 SmartMixin 계정을 만드세요.",
  "providerIntro.step1": "SmartMixin 계정에 로그인하세요 ({provider} 로그인이 아닙니다).",
  "providerIntro.step3EmailPassword": "여기에 입력하세요.",
  "providerIntro.step3KeyOrToken": "여기에 붙여넣으세요.",
  "providerIntro.step3OAuth": "팝업에서 SmartMixin을 승인하세요.",
  "providerIntro.step3Wunderground": "API 키를 붙여넣은 다음 가까운 스테이션을 선택하거나 임의의 스테이션 ID를 입력하세요.",
  "providerIntro.stepOfTotal": "{total}단계 중 {step}단계",
  "providerIntro.title": "{provider} 연결",
  "providerIntro.weatherflowStep2": "개인용 Tempest 토큰을 받으세요.",
  "providerIntro.wundergroundBrowsePublic": "스테이션이 없으신가요? 공개 스테이션 둘러보기",
  "providerIntro.wundergroundFindNearby": "주변 스테이션 찾기",
  "providerIntro.wundergroundOrEnterId": "또는 스테이션 ID 입력",
  "providerIntro.wundergroundStep2": "Weather Underground API 키를 받으세요. 그러면 본인의 스테이션이든 공개 스테이션이든 어떤 스테이션이든 연결할 수 있습니다.",
  "reports.agroMeteorology": "농업기상학",
  "reports.analysis": "분석",
  "reports.annualCumulativeRainfallComparison": "연간 누적 강우량 비교",
  "reports.annualHeatingDurationComparison": "연간 난방시간 비교",
  "reports.annualHeatingEfficiency": "연간 난방효율",
  "reports.annualIndoorComparison": "연간 실내 비교",
  "reports.annualOutdoorComparison": "연간 야외 비교",
  "reports.annualOutdoorReport": "연례 야외 보고서",
  "reports.annualReport": "연간 보고서",
  "reports.annualSolarReport": "연간 태양광 보고서",
  "reports.annualWaterBalance": "연간 물수지",
  "reports.annualWaterBalanceCarryOver": "{year}년 이월 ({value})",
  "reports.annualWaterBalanceDescription": "물 균형(단순 버전, 비와 증발산만 사용)은 물 공급 관리에 도움이 됩니다.",
  "reports.avgHumidity": "평균 습도",
  "reports.avgMaxTemperature": "평균 T°max",
  "reports.avgMetric": "평균 {metric}",
  "reports.avgMinTemperature": "평균 T°min",
  "reports.avgPressure": "평균 기압",
  "reports.avgTemperature": "평균 온도",
  "reports.chartsAndTable": "차트 및 표",
  "reports.climateNormalPeriodOfRecord": "관측기간 ({years}년)",
  "reports.climateNormals": "기후 평년값",
  "reports.climateNormalStandardLabel": "표준 평년값 ({period})",
  "reports.climateTrendPerDecade": "기온 추세: {years}년간 10년당 {value}",
  "reports.coldestMonthRanking": "관측 사상 가장 추운 {month}",
  "reports.comfortable": "편안함(45% {lessThan} 습도 ≤ 60%)",
  "reports.cumulativeRainfall": "누적 강우량",
  "reports.cumulativeRainfallDescription": "선택한 기간에 누적된 총 강우량을 확인하세요.",
  "reports.dailyMaxRainfall": "일일 최대 강우",
  "reports.dataExport": "데이터 내보내기",
  "reports.dataExportXlsxFormatDescription": "스테이션의 모든 데이터를 Excel 형식(*.xlsx)으로 내보냅니다. 버튼을 클릭하면 몇 분 후에 처리된 데이터가 포함된 이메일을 받게 됩니다.",
  "reports.daysOfData": "{days}일간의 데이터",
  "reports.daysWithFrost": "서리가 내리는 날",
  "reports.daysWithHeavyRain": "많은 비가 내린 날수 (≥ {threshold})",
  "reports.daysWithoutThaw": "해빙되지 않는 날",
  "reports.daysWithStrongFrost": "서리가 많이 내리는 날",
  "reports.emailSent": "이메일이 귀하의 사서함으로 전송되었습니다",
  "reports.frostDays": "서리일수",
  "reports.grasslandTemperatureSum": "초원 온도 합계",
  "reports.grasslandTemperatureSumDescription": "봄에 {threshold} 의 합계가 초과되면 지속 가능한 식생 시작에 도달한 것입니다(유럽에서 작동).",
  "reports.growingDegreeDays": "생육적산온도",
  "reports.highPressure": "고기압 (평균 기압 ≥ {threshold})",
  "reports.iceDays": "결빙일수",
  "reports.indoorReport": "실내 보고서",
  "reports.keyFacts": "중요한 사실",
  "reports.longestDrySpell": "최장 연속 무강수일수",
  "reports.longestRunOfRainyDays": "최장 연속 강우일수",
  "reports.longestRunWithoutRun": "비 없는 최장 연속일수",
  "reports.longestWetSpell": "최장 연속 강수일수",
  "reports.lowPressure": "저기압 (평균 기압 {lessThan} {threshold})",
  "reports.maxHumidity": "최대 습도",
  "reports.maxMetric": "최대 {metric}",
  "reports.maxPressure": "최고 기압",
  "reports.maxTemperature": "최대 온도",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "최대 일교차",
  "reports.minHumidity": "최소 습도",
  "reports.minMetric": "최소 {metric}",
  "reports.minPressure": "최저 기압",
  "reports.minTemperature": "최저온도",
  "reports.minTempMagnitude24h": "최소 일교차",
  "reports.monthlyAverageCountdown": "이번 달 {days}일 더",
  "reports.monthlyAverageCountdownDetail": "그러면 이번 달 평균과 순위가 표시됩니다.",
  "reports.monthlyAverageRule": "한 달에 {days}일이 기록되면 월 평균과 순위가 표시됩니다.",
  "reports.monthlyHeatingEfficiency": "월별 난방효율",
  "reports.monthlyOutdoorReport": "월간 야외 보고서",
  "reports.monthlyReport": "월별보고",
  "reports.monthlySolarReport": "월간 태양광 보고서",
  "reports.monthlyWindReport": "월간 바람 보고서",
  "reports.monthsOfData": "{months}개월간의 데이터",
  "reports.numberOfDays": "일 수",
  "reports.outdoorReport": "옥외보고",
  "reports.overviewSection": "개요",
  "reports.rainfall": "강우",
  "reports.rainyDays": "비오는 날",
  "reports.recordClimatologicalDay": "기후학적 일 (06–06 UTC)",
  "reports.recordClimDayBody": "여기서는 강수량을 관측소 시간 기준 자정부터 자정까지 달력 날짜별로 합산합니다. 기상 기관은 06:00부터 06:00 UTC까지 합산하므로, 자정 무렵의 폭풍우 때문에 다른 날이 가장 비가 많이 온 날이 될 수 있습니다.",
  "reports.recordDailyRain": "가장 비가 많이 온 날",
  "reports.recordFromHourlyReadings": "매시 관측값 기준",
  "reports.recordHigh": "최고 기온 기록",
  "reports.recordLow": "최저 기온 기록",
  "reports.recordOfficialBody": "기상 기관은 이 관측소에 대해 최고·최저 온도계로 읽은 일 최고·최저 기온을 발표합니다. 매시 관측이 놓치는 짧은 최고점까지 잡아내므로, 매시 관측으로 계산한 값을 대신합니다.",
  "reports.recordOfficialValue": "공식 값",
  "reports.recordsAndClimatology": "기록 및 기후",
  "reports.recordSheetTitle": "이 기록에 대하여",
  "reports.recordsSince": "{date} 이후 기록",
  "reports.recordWindGust": "최대 순간풍속",
  "reports.relativelyWet": "상대적으로 습함(60% {lessThan} 습도 ≤ 80%)",
  "reports.sectionReportCount": "{count}개의 보고서",
  "reports.sendEmail": "이메일 보내기",
  "reports.summerDays": "여름일수",
  "reports.tableScrollRegion": "{title}, 가로로 스크롤됨",
  "reports.tooDry": "너무 건조함(습도 45% 이하)",
  "reports.tooWet": "너무 습함(습도 {greaterThan} 80%)",
  "reports.tropicalNights": "열대야",
  "reports.unlockPremiumSubtitle": "SmartMixin Premium에 포함",
  "reports.unlockPremiumTitle": "프리미엄 기능 {count}개 잠금 해제",
  "reports.warmestMonthRanking": "관측 사상 가장 더운 {month}",
  "reports.waterBalance": "물수지",
  "reports.yearsOfData": "{years}년간의 데이터",
  "reports.yearToDateTemperatureComparison": "연초부터 현재까지 기온 비교",
  "sensors.bgtSensors": "흑구 & WBGT",
  "sensors.cameraFeed": "카메라",
  "sensors.compareHumidity": "습도 비교",
  "sensors.compareMoisture": "토양 수분 비교",
  "sensors.comparePm25": "PM2.5 비교",
  "sensors.compareTemperatures": "온도 비교",
  "sensors.compareWaterTension": "토양 수분 장력 비교",
  "sensors.depthByChannel": "채널별 깊이",
  "sensors.heatStressExtreme": "극심한 열 스트레스",
  "sensors.heatStressModerate": "보통 열 스트레스",
  "sensors.heatStressNone": "열 스트레스 없음",
  "sensors.heatStressStrong": "강한 열 스트레스",
  "sensors.heatStressVeryStrong": "매우 강한 열 스트레스",
  "sensors.indoorClimate": "실내 기후",
  "sensors.indoorCo2Levels": "CO2 수준",
  "sensors.indoorTemperatureAndHumidity": "온도 및 습도",
  "sensors.leafWetnessByChannel": "채널별 잎 습도",
  "sensors.lightningSensor": "번개",
  "sensors.moistureByChannel": "채널별 토양 수분",
  "sensors.noDataAvailable": "데이터 없음",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "채널별 PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "채널 선택",
  "sensors.sensorDetailDescription": "센서 채널의 과거 데이터와 추세를 확인하세요.",
  "sensors.sensorHistory": "센서 기록",
  "sensors.soilConductivityByChannel": "채널별 전도도",
  "sensors.soilTemperatureByChannel": "채널별 토양 온도",
  "sensors.strikesToday": "오늘 낙뢰 수",
  "sensors.temperatureByChannel": "채널별 온도",
  "sensors.viewChart": "차트 보기",
  "sensors.waterTensionByChannel": "채널별 토양 수분 장력",
  "settings.appearance": "외관",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "아랍어",
  "settings.bulgarian": "불가리아어",
  "settings.catalan": "카탈루냐어",
  "settings.chartGestures": "차트의 제스처",
  "settings.chartGesturesDescription": "차트를 스와이프하면 기간이 변경되고, 차트를 핀치하면 시간 척도가 변경됩니다.",
  "settings.choiceCount": "{count, plural, other {#개 사용 가능}}",
  "settings.contactUs": "문의하기",
  "settings.contactUsDescription": "도움을 받거나 피드백을 보내세요",
  "settings.croatian": "크로아티아어",
  "settings.czech": "체코어",
  "settings.dailyDetailByPeriods": "시간대별 일별 상세",
  "settings.dailyDetailByPeriodsDescription": "24시간을 밤, 아침, 오후, 저녁으로 묶습니다. 일별 요약과 동일한 구분입니다.",
  "settings.danish": "덴마크어",
  "settings.dark": "어두운 테마",
  "settings.dataDisplay": "데이터 표시",
  "settings.dateAndTime": "날짜와 시간",
  "settings.donateButton": "기부하기",
  "settings.donateDescription": "SmartMixin은 소규모 팀이 개발하고 있습니다. 유용하게 사용하고 계신다면 원하는 금액의 일회성 기부로 개발을 후원하실 수 있습니다. 이것은 선물이며, 요금제를 변경하거나 어떤 기능도 잠금 해제하지 않습니다.",
  "settings.donateSuccessBody": "여러분의 기부는 SmartMixin을 운영하고 개선하는 데 도움이 됩니다. 진심으로 감사드립니다.",
  "settings.donateSuccessTitle": "후원해 주셔서 감사합니다!",
  "settings.donateTitle": "SmartMixin 후원하기",
  "settings.dragToReorder": "끌어서 순서 변경",
  "settings.dutch": "네덜란드어",
  "settings.english": "영어",
  "settings.french": "프랑스어",
  "settings.german": "독일어",
  "settings.gestures": "제스처",
  "settings.greek": "그리스어",
  "settings.hungarian": "헝가리어",
  "settings.italian": "이탈리아어",
  "settings.japanese": "일본어",
  "settings.korean": "한국어",
  "settings.language": "언어",
  "settings.languageDescription": "선호하는 언어",
  "settings.light": "밝은 테마",
  "settings.measurementUnits": "측정 단위",
  "settings.netatmoDashboard": "Netatmo 대시보드",
  "settings.netatmoLayoutCards": "카드 목록",
  "settings.netatmoLayoutCardsDescription": "모듈당 카드 하나, 한 번의 스크롤로",
  "settings.netatmoLayoutClassic": "클래식",
  "settings.netatmoLayoutClassicDescription": "카드 두 개, 모듈 간 전환",
  "settings.netatmoNewLayoutNotice": "새 레이아웃: 모듈당 카드 하나.",
  "settings.netatmoSwitchBackToClassic": "클래식으로 되돌리기",
  "settings.netatmoSwitchToLayout": "{layout}(으)로 전환",
  "settings.norwegian": "노르웨이어",
  "settings.notificationsSection": "알림",
  "settings.ongoingNotificationEnabled": "상시 알림 활성화",
  "settings.ongoingNotificationMetrics": "표시할 측정값",
  "settings.ongoingNotificationPermissionRequired": "알림 권한이 필요합니다",
  "settings.ongoingNotificationPreviewHint": "미리 보기 — 위젯을 켜면 표시됩니다",
  "settings.ongoingNotificationStatusBar": "상태 표시줄",
  "settings.polish": "폴란드어",
  "settings.portuguese": "포르투갈어",
  "settings.preferencesSection": "환경설정",
  "settings.privacyPolicy": "개인정보 처리방침",
  "settings.russian": "러시아어",
  "settings.serbian": "세르비아어",
  "settings.settings": "설정",
  "settings.settingsPageTitle": "설정 - {page}",
  "settings.slovak": "슬로바키아어",
  "settings.smallDecimals": "작은 소수점",
  "settings.smallDecimalsDescription": "소수점 이하 숫자를 작은 크기로 표시",
  "settings.spanish": "스페인어",
  "settings.statusBarWidget": "상태 표시줄 위젯",
  "settings.statusBarWidgetDescription": "항상 표시되는 날씨 데이터",
  "settings.subscriptionSection": "구독",
  "settings.supportSection": "지원",
  "settings.swedish": "스웨덴어",
  "settings.systemTheme": "시스템 테마",
  "settings.termsOfService": "서비스 약관",
  "settings.themeDarkShort": "다크",
  "settings.themeLightShort": "라이트",
  "settings.themeSystemShort": "시스템",
  "settings.turkish": "터키어",
  "settings.ukrainian": "우크라이나어",
  "settings.units": "단위",
  "settings.unitsDescription": "애플리케이션 내에 표시되는 측정 단위",
  "settings.update": "업데이트",
  "settings.windDirectionConvention": "풍향 화살표",
  "settings.windDirectionConventionDescription": "풍향 화살표 표시 방법 선택",
  "settings.windDirectionMeteorological": "불어오는 방향",
  "settings.windDirectionMeteorologicalDescription": "화살표가 바람이 불어오는 방향을 가리킵니다 (기상학 관례)",
  "settings.windDirectionOceanographic": "불어가는 방향",
  "settings.windDirectionOceanographicDescription": "화살표가 바람이 불어가는 방향을 가리킵니다 (해양학 관례)",
  "stations.addAStation": "관측소 추가",
  "stations.addToFavorites": "즐겨찾기에 추가",
  "stations.addYourOwnStation": "나만의 관측소 추가",
  "stations.clearRecentLocations": "모두 지우기",
  "stations.clearSearch": "검색 지우기",
  "stations.currentLocation": "현재 위치",
  "stations.customizedStationName": "맞춤형 관측소 이름",
  "stations.favoriteLocations": "즐겨찾기",
  "stations.favoriteLocationsEmpty": "즐겨찾는 위치를 최대 5개까지 추가할 수 있습니다.",
  "stations.favoriteStations": "즐겨찾는 관측소",
  "stations.filterStationDescription": "신뢰할 수 없는 측정값이 있는 관측소를 표시하지 않음",
  "stations.filterStations": "관측소 필터링",
  "stations.filterStationSourceDescription": "지도에 표시할 관측소 제공자를 선택하세요.",
  "stations.findStationsNearYou": "주변 관측소 찾기",
  "stations.hiddenStations": "숨겨진 관측소",
  "stations.hiddenStationsDescription": "옆에 있는 눈 아이콘을 탭하면 관측소를 다시 표시할 수 있습니다.",
  "stations.hideStationNamed": "{station} 숨기기",
  "stations.lastSeen": "마지막 수신 {time}",
  "stations.loadingStation": "관측소를 불러오는 중…",
  "stations.location": "위치",
  "stations.locationAddedToFavorites": "위치가 즐겨찾기에 추가되었습니다",
  "stations.locationNotGranted": "위치 권한이 허용되지 않았습니다. 기기 설정에서 위치 접근을 허용해 주세요.",
  "stations.locationRemovedFromFavorites": "위치가 즐겨찾기에서 삭제되었습니다",
  "stations.locations": "위치",
  "stations.locationUnavailable": "위치를 가져올 수 없습니다. 기기 설정을 확인해 주세요.",
  "stations.maxFavoriteLocationsReached": "즐겨찾는 위치는 최대 5개까지 저장할 수 있습니다. 다른 위치를 추가하려면 하나를 삭제하세요.",
  "stations.modifyFavoriteStations": "즐겨찾는 관측소 수정",
  "stations.modifyFavoriteStationsDescription": "즐겨찾는 관측소를 드래그하여 순서를 바꿀 수 있습니다. 목록에서 삭제할 수도 있습니다.",
  "stations.myLocation": "내 위치",
  "stations.nearbyWeatherStations": "인근 기상 관측소",
  "stations.noLocationsFound": "위치를 찾을 수 없습니다",
  "stations.noLongerReported": "더 이상 목록에 없음",
  "stations.noLongerReportedBy": "{date}부터 {provider} 목록에 없음",
  "stations.noSearchResults": "검색과 일치하는 문서가 없습니다",
  "stations.noStationsFound": "관측소를 찾을 수 없습니다",
  "stations.noWeatherStationYet": "아직 기상 관측소가 없습니다.",
  "stations.recentLocations": "최근",
  "stations.recentLocationsEmpty": "최근 기록이 없습니다.",
  "stations.removeFromFavorites": "즐겨찾기에서 삭제",
  "stations.removeStationNamed": "즐겨찾기에서 {station} 삭제",
  "stations.reorderStationNamed": "{station} 이동",
  "stations.searchForLocation": "위치 검색",
  "stations.searchForWeatherStation": "기상 관측소 검색",
  "stations.searchResults": "검색 결과",
  "stations.searchResultsEmpty": "결과가 없습니다.",
  "stations.searchResultsFound": "{count}개의 결과를 찾았습니다",
  "stations.searchStationsDescription": "도시, 주소 또는 장소명을 입력하여 주변 기상 관측소를 찾으세요.",
  "stations.searchStationsHint": "위의 검색창을 사용하여 전 세계 어디서나 기상 관측소를 찾아보세요.",
  "stations.selectStationForComparison": "비교할 관측소를 선택하세요.",
  "stations.stationAddedToFavorites": "즐겨찾기에 관측소가 추가되었습니다",
  "stations.stationCount": "{count, plural, other {관측소 #곳}}",
  "stations.stationInformation": "관측소 정보",
  "stations.stationName": "관측소 이름",
  "stations.stationObservationsDescription": "기상 관측소의 최신 관측치를 표시합니다.",
  "stations.stationRemovedFromFavorites": "즐겨찾기에서 관측소가 삭제되었습니다.",
  "stations.stationsLoading": "기상 관측소를 불러오는 중",
  "stations.stationsNear": "{place} 주변 관측소",
  "stations.stationType": "관측소 유형",
  "stations.statusOffline": "오프라인",
  "stations.statusOnline": "온라인",
  "stations.statusStale": "오래됨",
  "stations.tryAnotherLocation": "이 위치 주변에서 기상 관측소를 찾을 수 없습니다. 다른 지역에서 검색해 보세요.",
  "stations.unhideStationNamed": "{station} 다시 표시",
  "stations.weatherStation": "기상 관측소",
  "stations.weatherStationCount": "{count, plural, other {기상 관측소 #곳}}",
  "stations.weatherStations": "기상 관측소",
  "stations.welcomeConnectService": "기상 관측소를 보유하고 계신가요? 서비스를 연결하세요",
  "stations.welcomeSubtitle": "날씨 정보를 한곳에서",
  "thermostat.away": "외출",
  "thermostat.boilerOn": "보일러 ON",
  "thermostat.hg": "동파 방지",
  "thermostat.homeInformation": "홈 정보",
  "thermostat.homeName": "집 이름",
  "thermostat.manualBoost": "수동 부스트",
  "thermostat.manualSetpointUntil": "수동 설정 종료 시각",
  "thermostat.noThermostatYet": "아직 온도 조절기가 없습니다.",
  "thermostat.relay": "계전기",
  "thermostat.room": "방",
  "thermostat.rooms": "방",
  "thermostat.smartThermostat": "스마트 온도 조절기",
  "thermostat.smartValve": "스마트 밸브",
  "thermostat.whenBackHome": "언제 집에 돌아올 거예요?",
  "units.celsius": "섭씨",
  "units.fahrenheit": "화씨",
  "units.inch": "인치",
  "units.inchOfMercury": "수은주 인치",
  "units.kelvin": "켈빈",
  "units.kilometerPerHour": "시간당 킬로미터",
  "units.knot": "노트",
  "units.meterPerSecond": "초당 미터",
  "units.milePerHour": "시간당 마일",
  "units.millibar": "밀리바",
  "units.millimeter": "밀리미터",
  "units.millimeterOfMercury": "수은주 밀리미터",
  "weatherConditions.blizzard": "눈보라",
  "weatherConditions.blowingDust": "날린 먼지",
  "weatherConditions.blowingSnow": "땅날림눈",
  "weatherConditions.breezy": "산들바람",
  "weatherConditions.clear": "맑음",
  "weatherConditions.cloudy": "흐림",
  "weatherConditions.drizzle": "이슬비",
  "weatherConditions.flurries": "약한 눈",
  "weatherConditions.foggy": "안개",
  "weatherConditions.freezingDrizzle": "어는 이슬비",
  "weatherConditions.freezingRain": "어는 비",
  "weatherConditions.frigid": "혹한",
  "weatherConditions.hail": "우박",
  "weatherConditions.haze": "연무",
  "weatherConditions.heavyRain": "폭우",
  "weatherConditions.heavySnow": "폭설",
  "weatherConditions.hot": "무더위",
  "weatherConditions.hurricane": "허리케인",
  "weatherConditions.isolatedThunderstorms": "국지적 뇌우",
  "weatherConditions.mixedRainAndHail": "비와 우박",
  "weatherConditions.mostlyClear": "대체로 맑음",
  "weatherConditions.mostlyCloudy": "구름 많음",
  "weatherConditions.mostlySunny": "대체로 화창함",
  "weatherConditions.notAvailable": "기상 상태를 확인할 수 없음",
  "weatherConditions.partlyCloudy": "구름 조금",
  "weatherConditions.rain": "비",
  "weatherConditions.rainSleet": "비와 얼음싸라기",
  "weatherConditions.rainSnow": "진눈깨비",
  "weatherConditions.scatteredShowers": "산발적인 소나기",
  "weatherConditions.scatteredSnowShowers": "산발적인 소낙눈",
  "weatherConditions.scatteredThunderstorms": "산발적인 뇌우",
  "weatherConditions.showers": "소나기",
  "weatherConditions.sleet": "얼음싸라기",
  "weatherConditions.smoke": "연기",
  "weatherConditions.snow": "눈",
  "weatherConditions.snowShowers": "소낙눈",
  "weatherConditions.strongStorms": "강한 뇌우",
  "weatherConditions.sunny": "화창함",
  "weatherConditions.thunderstorms": "뇌우",
  "weatherConditions.tornado": "토네이도",
  "weatherConditions.tropicalStorm": "열대성 폭풍",
  "weatherConditions.windy": "바람 많음",
  "weatherConditions.wintryMix": "겨울철 혼합 강수",
  "weatherMap.clusterMarkerName": "{metric} {value}, 관측소 {count, plural, other {#}}개의 중앙값, 확대",
  "weatherMap.legendHeavy": "강함",
  "weatherMap.legendLight": "약함",
  "weatherMap.legendLightningHelp": "색상은 지난 {minutes}분 동안 각 낙뢰의 경과 시간을 나타냅니다 — 최신은 흰색, 오래된 것은 짙은 빨간색입니다.",
  "weatherMap.legendNewest": "최신",
  "weatherMap.legendOldest": "오래됨",
  "weatherMap.legendStationsHelp": "마커 색상은 선택한 지표의 값을 나타냅니다.",
  "weatherMap.lightningDataAttribution": "번개 데이터: Blitzortung.org",
  "weatherMap.lightningStrikes": "낙뢰",
  "weatherMap.lightningStrikesDescription": "지도에 실시간 낙뢰 표시",
  "weatherMap.mapLayers": "지도 레이어",
  "weatherMap.mapLegend": "지도 범례",
  "weatherMap.mapMode": "지도 모드",
  "weatherMap.mapNameForecast": "예보 지도, {model}, {variable}",
  "weatherMap.mapNameObservations": "날씨 지도, 관측값",
  "weatherMap.modeForecast": "예보",
  "weatherMap.modeObservations": "관측값",
  "weatherMap.radarDataAttribution": "레이더 데이터: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "레이더 시각",
  "weatherMap.rainRadar": "비 레이더",
  "weatherMap.rainRadarDescription": "지도에 레인 레이더 오버레이 표시",
  "weatherMap.resetBearing": "드래그하여 지도 회전, 클릭하여 북쪽 방향으로 재설정",
  "weatherMap.showingForecast": "표시 중인 예보: {model}, {variable}",
  "weatherMap.signInForecastBody": "SmartMixin 계정이 있으면 GFS 지도를 무료로 이용할 수 있습니다. 프리미엄에서는 더 많은 모델을 사용할 수 있습니다.",
  "weatherMap.signInForecastTitle": "예보 지도를 보려면 로그인하세요",
  "weatherMap.stationMarkerName": "{metric} {value}, 관측소 1개",
  "weatherMap.stationMarkersHint": "화살표 키로 관측소 사이를 이동합니다",
  "weatherMap.stationMarkerWindValue": "{speed}, 풍향 {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain은 Nearcast Technology를 기반으로 하는 Tempest Weather System을 통해 제공되는 추가 데이터 소스입니다. NC Rain 데이터는 지역 수준에서 Tempest 주변의 평균 강수량 누적에 대한 추정치입니다.",
  "weatherMap.weatherMap": "기상도",
  "weatherMap.weatherMapMetaDescription": "SmartMixin은 전 세계 기상 조건에 대한 대화형 날씨 및 레이더 지도를 제공합니다.",
  "weatherMap.zoomIn": "확대",
  "weatherMap.zoomOut": "축소",
  "weatherWarnings.activeNow": "현재 발효 중",
  "weatherWarnings.agencyMessage": "기상 기관 메시지",
  "weatherWarnings.areaCovered": "대상 지역",
  "weatherWarnings.areaThisLocation": "{area} (이 위치)",
  "weatherWarnings.areaYourStation": "{area} (내 기상 관측소)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {공식 특보, {severity}: {hazard}} other {공식 특보, {severity}: {hazard}, 외 #건}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {예정된 공식 특보, {severity}: {hazard}} other {예정된 공식 특보, {severity}: {hazard}, 외 #건}}",
  "weatherWarnings.crumb": "공식 특보",
  "weatherWarnings.emptyBody": "국가 기상청이 이 장소에 발표한 특보가 없습니다. 몇 분마다 다시 확인합니다.",
  "weatherWarnings.emptyTitle": "공식 특보 없음",
  "weatherWarnings.ended": "종료됨",
  "weatherWarnings.endedAt": "이 특보는 {time}에 종료되었습니다.",
  "weatherWarnings.errorBody": "연결을 확인해 주세요. 몇 분마다 다시 시도합니다.",
  "weatherWarnings.errorTitle": "공식 특보를 불러오지 못했습니다",
  "weatherWarnings.fromTime": "{time}부터",
  "weatherWarnings.hazardAirQuality": "공기질",
  "weatherWarnings.hazardAvalanche": "눈사태",
  "weatherWarnings.hazardCoastalEvent": "해안 위험",
  "weatherWarnings.hazardFlood": "홍수",
  "weatherWarnings.hazardFog": "안개",
  "weatherWarnings.hazardForestFire": "산불",
  "weatherWarnings.hazardHighTemperature": "고온",
  "weatherWarnings.hazardLowTemperature": "저온",
  "weatherWarnings.hazardOther": "기타 위험",
  "weatherWarnings.hazardRain": "비",
  "weatherWarnings.hazardSnowIce": "눈과 결빙",
  "weatherWarnings.hazardThunderstorm": "뇌우",
  "weatherWarnings.hazardUv": "자외선",
  "weatherWarnings.hazardWind": "바람",
  "weatherWarnings.hideHazards": "위험 요소 숨기기",
  "weatherWarnings.issuedBy": "발표: {sender}",
  "weatherWarnings.lastUpdate": "마지막 업데이트: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {대상 지역 지도: {area}.} other {대상 지역 #곳의 지도. {area} 강조 표시됨.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {대상 지역 지도.} other {대상 지역 #곳의 지도.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {지도를 사용할 수 없습니다. 지역은 아래에 나와 있습니다.} other {지도를 사용할 수 없습니다. #개 지역이 아래에 나와 있습니다.}}",
  "weatherWarnings.moreHazards": "외 {count}건: {hazards}",
  "weatherWarnings.notInLanguage": "{language}(으)로 제공되지 않습니다. 기상 기관이 발표한 그대로 표시합니다.",
  "weatherWarnings.openOn": "{site}에서 열기",
  "weatherWarnings.otherAreas": "{count, plural, other {외 #개 지역}}",
  "weatherWarnings.severityExtreme": "극심",
  "weatherWarnings.severityFrom": "{time}부터 {severity}",
  "weatherWarnings.severityMinor": "경미",
  "weatherWarnings.severityModerate": "보통",
  "weatherWarnings.severityNow": "현재 {severity}",
  "weatherWarnings.severitySevere": "심각",
  "weatherWarnings.severityUntil": "{time}까지 {severity}",
  "weatherWarnings.showAllAreas": "{count, plural, other {#개 지역 모두 보기}}",
  "weatherWarnings.showAllOnMap": "{count, plural, other {지도에서 #개 지역 모두 보기}}",
  "weatherWarnings.showHazards": "위험 요소 보기",
  "weatherWarnings.showPeriods": "{count, plural, other {#개 기간 모두 보기}}",
  "weatherWarnings.source": "출처: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, 이후 {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, other {공식 기상 특보 #건}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "공식 기상 특보",
  "weatherWarnings.todayAt": "오늘 {time}",
  "weatherWarnings.tomorrow": "내일",
  "weatherWarnings.tomorrowAt": "내일 {time}",
  "weatherWarnings.upcoming": "예정",
  "weatherWarnings.viewAll": "모든 공식 특보",
  "weatherWarnings.whatToDo": "행동 요령"
}
